(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ehobby-aov-drawer-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.EhobbyAovCartState) return;
  class CartState {
    constructor({ root = window.Shopify?.routes?.root || '/', request = fetch, onState = () => {} } = {}) {
      this.root = new URL(root, location.origin);
      if (this.root.origin !== location.origin) throw new Error('Unexpected cart origin');
      this.request = (...args) => request(...args);
      this.onState = onState;
      this.cart = null;
      this.pending = 0;
      this.uncertain = false;
      this.error = null;
    }
    emit(error = this.error) {
      this.error = error;
      this.onState({ cart: this.cart, pending: this.pending > 0, uncertain: this.uncertain, error });
    }
    async json(path, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        let response;
        for (let attempt = 0; attempt < 3; attempt++) {
          response = await this.request(new URL(path, this.root), {
            ...options, credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
            headers: { Accept: 'application/json', ...options.headers },
          });
          if ((options.method || 'GET') !== 'GET' || ![429, 502, 503, 504].includes(response.status) || attempt === 2) break;
          const retryAfter = Number(response.headers?.get?.('Retry-After'));
          if (retryAfter > 4) break;
          await new Promise(resolve => setTimeout(resolve, retryAfter > 0 ? retryAfter * 1000 : 1000 * (attempt + 1)));
        }
        const body = await response.json();
        if (!response.ok) {
          const error = new Error(typeof body.description === 'string' ? body.description : 'Cart request failed');
          error.status = response.status;
          throw error;
        }
        return body;
      } finally { clearTimeout(timer); }
    }
    accept(cart) {
      const keys = new Set();
      if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0
        || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || typeof cart.currency !== 'string' || !/^[A-Z]{3}$/.test(cart.currency)
        || !cart.items.every(item => {
          if (!item || typeof item.key !== 'string' || !item.key.trim() || keys.has(item.key)
            || !Number.isSafeInteger(item.variant_id) || item.variant_id < 1
            || !Number.isSafeInteger(item.quantity) || item.quantity < 1) return false;
          keys.add(item.key);
          return true;
        })
        || cart.items.reduce((count, item) => count + item.quantity, 0) !== cart.item_count) {
        throw new Error('Invalid cart response');
      }
      this.cart = cart;
      return cart;
    }
    async queued(operation) {
      const previous = window.EhobbyAovCartQueue || Promise.resolve();
      let release;
      window.EhobbyAovCartQueue = new Promise(resolve => { release = resolve; });
      this.pending++;
      this.emit();
      try {
        await previous.catch(() => {});
        this.error = null;
        return await operation();
      } catch (error) {
        this.emit(error);
        throw error;
      } finally {
        this.pending--;
        release();
        this.emit();
      }
    }
    refresh() {
      return this.queued(async () => {
        try {
          const cart = this.accept(await this.json('cart.js'));
          this.uncertain = false;
          return cart;
        } catch (error) {
          this.uncertain = true;
          throw error;
        }
      });
    }
    mutate(path, payload, fullCart, expectedLine = null, beforeAdd = null) {
      return this.queued(async () => {
        if (this.uncertain) throw new Error('Review the cart before making another change');
        if (path === 'cart/change.js') {
          let fresh;
          try { fresh = this.accept(await this.json('cart.js')); }
          catch (error) { this.uncertain = true; throw error; }
          const current = fresh.items.find(item => item.key === payload.id);
          if (!expectedLine || !current || current.variant_id !== expectedLine.variant_id || current.quantity !== expectedLine.quantity) {
            throw new Error('Cart changed; review the updated cart before trying again');
          }
        }
        const additions = path === 'cart/add.js' ? payload.items : [];
        if (additions.length && beforeAdd !== null) {
          let fresh;
          try { fresh = this.accept(await this.json('cart.js')); }
          catch (error) { this.uncertain = true; throw error; }
          if (typeof beforeAdd !== 'function' || await beforeAdd(fresh) !== true
            || additions.some(item => fresh.items.some(line => String(line.variant_id) === String(item.id)))) {
            try { this.accept(await this.json('cart.js')); }
            catch (error) { this.uncertain = true; throw error; }
            throw new Error('Optional pairing needs an updated cart review');
          }
        }
        window.EhobbyAovUncertainVariants ||= new Set();
        if (additions.some(item => window.EhobbyAovUncertainVariants.has(String(item.id)))) {
          throw new Error('Review the cart before adding this item again');
        }
        additions.forEach(item => window.EhobbyAovUncertainVariants.add(String(item.id)));
        const removal = path === 'cart/change.js' && payload.quantity === 0 ? this.cart?.items?.find(item => item.key === payload.id) : null;
        try {
          const body = await this.json(path, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
          });
          if (additions.length && (!Array.isArray(body?.items) || body.items.length !== additions.length
            || !additions.every(item => body.items.filter(added => String(added?.id) === String(item.id)
              && Number.isSafeInteger(added.quantity) && added.quantity === item.quantity).length === 1))) {
            throw new Error('Review the cart: the added items could not be confirmed');
          }
          const cart = this.accept(fullCart ? body : await this.json('cart.js'));
          additions.forEach(item => window.EhobbyAovUncertainVariants.delete(String(item.id)));
          window.EhobbyAovRemovalPreferences?.confirmRemoval(removal, payload.quantity, cart);
          return cart;
        } catch (error) {
          this.uncertain = true;
          try {
            const cart = this.accept(await this.json('cart.js'));
            window.EhobbyAovRemovalPreferences?.confirmRemoval(removal, payload.quantity, cart);
            this.uncertain = false;
          } catch {}
          throw error;
        }
      });
    }
    change(key, quantity) {
      if (typeof key !== 'string' || !key || !Number.isSafeInteger(quantity) || quantity < 0) {
        return Promise.reject(new Error('Invalid cart change'));
      }
      const item = this.cart?.items?.find(line => line.key === key);
      const expectedLine = item ? { variant_id: item.variant_id, quantity: item.quantity } : null;
      return this.mutate('cart/change.js', { id: key, quantity }, true, expectedLine);
    }
    add(variantId, quantity = 1, beforeAdd = null) {
      if (!/^\d+$/.test(String(variantId)) || !Number.isSafeInteger(quantity) || quantity < 1) {
        return Promise.reject(new Error('Invalid cart item'));
      }
      return this.mutate('cart/add.js', { items: [{ id: String(variantId), quantity }] }, false, null, beforeAdd);
    }
  }
  window.EhobbyAovCartState = CartState;
})();

(() => {
  if (window.EhobbyAovShipping) return;
  class Shipping {
    constructor(element) {
      this.element = element;
      this.panel = element.querySelector('[data-drawer-shipping]');
      this.form = this.panel.querySelector('form');
      this.status = this.panel.querySelector('[data-shipping-status]');
      this.rates = this.panel.querySelector('[data-shipping-rates]');
      this.button = this.form.querySelector('button');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.form.elements.country.value = '';
      this.form.addEventListener('submit', event => { event.preventDefault(); this.estimate(); }, options);
      this.form.addEventListener('input', () => this.invalidate(), options);
      this.form.elements.country.addEventListener('change', () => {
        this.invalidate();
        let provinces = [];
        try { provinces = JSON.parse(this.form.elements.country.selectedOptions[0]?.dataset.provinces || '[]'); } catch {}
        const select = this.form.elements.province;
        select.replaceChildren(new Option('', ''));
        if (Array.isArray(provinces)) provinces.forEach(province => {
          if (Array.isArray(province) && province.length > 1) select.add(new Option(province[1], province[0]));
        });
        select.required = select.options.length > 1;
        this.panel.querySelector('[data-shipping-province-wrap]').hidden = !select.required;
      }, options);
    }
    invalidate() {
      this.version = (this.version || 0) + 1;
      this.request?.abort();
      this.status.textContent = '';
      this.rates.replaceChildren();
      this.button.disabled = Boolean(this.busy);
    }
    update(cart, busy) {
      if (this.cart !== cart || busy !== this.busy) {
        this.cart = cart;
        this.busy = busy;
        this.invalidate();
      }
      this.panel.hidden = !cart?.item_count || cart.requires_shipping !== true;
    }
    async estimate() {
      if (this.busy || !this.cart?.item_count || !this.form.reportValidity() || this.button.disabled) return;
      this.invalidate();
      const version = this.version;
      const controller = new AbortController();
      this.request = controller;
      const timer = setTimeout(() => controller.abort(), 18000);
      this.button.disabled = true;
      this.status.textContent = this.element.dataset.shippingLoading;
      const params = new URLSearchParams();
      for (const key of ['country', 'province', 'zip']) params.set(`shipping_address[${key}]`, this.form.elements[key].value.trim());
      const root = new URL(window.Shopify?.routes?.root || '/', location.origin);
      const request = async (path, method) => {
        const url = new URL(path, root);
        url.search = params.toString();
        let response;
        for (let attempt = 0; attempt < 3; attempt++) {
          response = await fetch(url, { method, credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
          if (method !== 'GET' || ![429, 502, 503, 504].includes(response.status) || attempt === 2) break;
          const retryAfter = Number(response.headers.get('Retry-After'));
          if (retryAfter > 4) break;
          await new Promise(resolve => setTimeout(resolve, retryAfter > 0 ? retryAfter * 1000 : 1000 * (attempt + 1)));
        }
        if (!response.ok) throw new Error('Shipping estimate unavailable');
        return response.json();
      };
      try {
        await request('cart/prepare_shipping_rates.json', 'POST');
        let result;
        for (let attempt = 0; attempt < 8; attempt++) {
          if (controller.signal.aborted) return;
          result = await request('cart/async_shipping_rates.json', 'GET');
          if (Array.isArray(result?.shipping_rates)) break;
          await new Promise(resolve => setTimeout(resolve, Math.min(1500, 300 * (attempt + 1))));
        }
        if (version !== this.version) return;
        if (!Array.isArray(result?.shipping_rates)) throw new Error('Shipping estimate timed out');
        const rows = document.createDocumentFragment();
        for (const rate of result.shipping_rates) {
          const currency = rate.currency || (this.cart.currency === this.element.dataset.shopCurrency ? this.cart.currency : null);
          const price = typeof rate.price === 'number' || (typeof rate.price === 'string' && rate.price.trim() !== '') ? Number(rate.price) : NaN;
          if (!currency || rate.price == null || !Number.isFinite(price) || price < 0) throw new Error('Ambiguous shipping price');
          const row = document.createElement('li');
          row.textContent = `${rate.presentment_name || rate.name} — ${new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(price)}`;
          rows.append(row);
        }
        this.rates.replaceChildren(rows);
        this.status.textContent = result.shipping_rates.length ? this.element.dataset.shippingReady : this.element.dataset.shippingEmpty;
      } catch {
        if (version === this.version) this.status.textContent = this.element.dataset.shippingError;
      } finally {
        clearTimeout(timer);
        if (version === this.version) this.button.disabled = Boolean(this.busy);
      }
    }
    destroy() { this.invalidate(); this.abort.abort(); }
  }
  window.EhobbyAovShipping = Shipping;
})();

(() => {
  if (window.EhobbyAovCartDrawer) return;
  class CartDrawer {
    constructor(element) {
      this.element = element;
      this.dialog = element.querySelector('dialog');
      this.lines = element.querySelector('[data-drawer-lines]');
      this.status = element.querySelector('[data-drawer-status]');
      this.subtotal = element.querySelector('[data-drawer-subtotal]');
      this.checkout = element.querySelector('[name="checkout"]');
      this.template = element.querySelector('template');
      this.abort = new AbortController();
      this.recommendations = element.querySelector('[data-drawer-recommendations]');
      this.recommendationVersion = 0;
      this.shipping = new window.EhobbyAovShipping(element);
      this.store = new window.EhobbyAovCartState({ onState: state => this.render(state) });
      const options = { signal: this.abort.signal };
      element.querySelector('[data-drawer-close]').addEventListener('click', () => this.dialog.close(), options);
      element.querySelector('[data-drawer-retry]').addEventListener('click', () => this.store.refresh().catch(() => {}), options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow;
        if (this.opener?.isConnected) this.opener.focus();
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.lines.addEventListener('click', event => {
        const button = event.target.closest('[data-line-action]');
        if (!button || button.disabled) return;
        const row = button.closest('[data-line-key]');
        const item = this.store.cart?.items.find(item => item.key === row.dataset.lineKey);
        if (!item) return;
        const quantity = button.dataset.lineAction === 'remove' ? 0 : item.quantity + Number(button.dataset.lineAction);
        this.store.change(item.key, quantity).catch(() => {});
      }, options);
      element.querySelector('[data-drawer-checkout]').addEventListener('submit', event => {
        if (this.store.pending || this.store.uncertain || !this.store.cart?.item_count) event.preventDefault();
      }, options);
      this.recommendations.addEventListener('submit', event => {
        const form = event.target;
        if (!form.matches('ehobby-aov-form form')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.store.pending || this.store.uncertain || !form.reportValidity()) return;
        const payload = new FormData(form);
        const card = form.closest('.ehobby-aov__card');
        const beforeAdd = card?.dataset.aovOptional === 'true'
          ? async cart => await window.EhobbyAovDiscovery?.checkOptionalSubmission?.(card, cart, [], String(payload.get('id'))) === true
          : null;
        this.store.add(payload.get('id'), Number(payload.get('quantity') || 1), beforeAdd).then(() => {
          window.EhobbyAovMetrics?.track('ehobby_aov_add', card, { variant_id: String(payload.get('id')), quantity: Number(payload.get('quantity') || 1) });
        }).catch(async error => {
          if (error.status === 422) await window.EhobbyAovDiscovery?.rejectIfUnavailable?.(card, payload.get('id'));
        });
      }, { ...options, capture: true });
    }
    open() {
      if (!this.dialog.open) {
        this.opener = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      return this.store.refresh().catch(() => {});
    }
    money(value, currency) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(value / 100);
    }
    safeURL(value) {
      try {
        const url = new URL(value, location.origin);
        return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
      } catch { return null; }
    }
    render({ cart, pending, uncertain, error }) {
      this.shipping.update(cart, pending || uncertain);
      if (pending || uncertain) {
        this.recommendationVersion++;
        this.recommendationRequest?.abort();
        this.recommendations.hidden = true;
      }
      this.lines.setAttribute('aria-busy', String(pending));
      this.status.textContent = error ? this.element.dataset.error : pending ? this.element.dataset.loading : '';
      this.element.querySelector('[data-drawer-retry]').hidden = !error && !uncertain;
      this.checkout.disabled = pending || uncertain || !cart?.item_count;
      if (cart && this.renderedCart !== cart) {
        const focused = document.activeElement;
        const focusedKey = focused?.closest('[data-line-key]')?.dataset.lineKey;
        const focusedAction = focused?.dataset.lineAction;
        const fragment = document.createDocumentFragment();
        for (const item of cart.items) {
          const row = this.template.content.firstElementChild.cloneNode(true);
          row.dataset.lineKey = item.key;
          row.querySelector('[data-line-title]').textContent = item.product_title || item.title;
          const link = row.querySelector('[data-line-link]');
          const href = this.safeURL(item.url);
          if (href) link.href = href;
          row.querySelector('[data-line-variant]').textContent = item.variant_title === 'Default Title' ? '' : item.variant_title || '';
          row.querySelector('[data-line-quantity]').textContent = String(item.quantity);
          row.querySelector('[data-line-price]').textContent = this.money(item.final_line_price, cart.currency);
          const img = row.querySelector('img');
          const src = this.safeURL(item.featured_image?.url || item.image || '');
          if (src && (item.featured_image?.url || item.image)) { img.src = src; img.alt = item.product_title || item.title; }
          else img.hidden = true;
          fragment.append(row);
        }
        this.lines.replaceChildren(fragment);
        this.subtotal.textContent = this.money(cart.total_price, cart.currency);
        this.element.querySelector('[data-drawer-empty]').hidden = cart.item_count !== 0;
        document.querySelectorAll('[data-header-cart-count]').forEach(counter => {
          counter.textContent = String(cart.item_count);
          counter.setAttribute('data-header-cart-count', String(cart.item_count));
          counter.classList.toggle('visible', cart.item_count > 0);
        });
        this.renderedCart = cart;
        if (focusedKey && this.dialog.open) {
          const row = [...this.lines.children].find(row => row.dataset.lineKey === focusedKey);
          const next = row && [...row.querySelectorAll('[data-line-action]')].find(button => button.dataset.lineAction === focusedAction);
          (next || this.element.querySelector('[data-drawer-close]')).focus();
        }
      }
      this.lines.querySelectorAll('button').forEach(button => { button.disabled = pending || uncertain; });
      if (!pending && !uncertain && cart && this.recommendationCart !== cart) {
        this.recommendationCart = cart;
        this.element.dispatchEvent(new CustomEvent('ehobby-aov:cart-rendered', { bubbles: true, detail: { cart } }));
        this.loadRecommendations(cart);
      }
    }
    async loadRecommendations(cart) {
      const version = ++this.recommendationVersion;
      this.recommendationRequest?.abort();
      this.recommendations.replaceChildren();
      this.recommendations.hidden = true;
      if (!cart.item_count || !window.EhobbyAovDiscovery || !window.EhobbyAovPersonalizer) return;
      const controller = new AbortController();
      this.recommendationRequest = controller;
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const url = new URL('cart', this.store.root);
        url.searchParams.set('section_id', 'ehobby-aov-drawer-recommendations');
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
        if (!response.ok) return;
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = parsed.querySelector('.ehobby-aov');
        if (!section || version !== this.recommendationVersion) return;
        section.querySelectorAll('script').forEach(script => script.remove());
        section.dataset.aovLimit = '2';
        section.dataset.aovBundle = 'false';
        this.recommendations.append(section);
        await window.EhobbyAovDiscovery.discover(section);
        if (version !== this.recommendationVersion) return;
        window.EhobbyAovPersonalizer.refresh(section);
        this.recommendations.hidden = false;
      } catch {
        if (version === this.recommendationVersion) this.recommendations.hidden = true;
      } finally { clearTimeout(timeout); }
    }
    destroy() {
      if (this.dialog.open) this.dialog.close();
      this.abort.abort();
      this.recommendationVersion++;
      this.recommendationRequest?.abort();
      this.store.onState = () => {};
      this.shipping.destroy();
    }
  }
  window.EhobbyAovCartDrawer = CartDrawer;
})();

(() => {
  if (window.EhobbyAovDrawerBridge) return;
  let drawer;
  const mount = () => {
    if (drawer?.element.isConnected) return drawer;
    drawer?.destroy();
    drawer = null;
    const shell = document.querySelector('[data-ehobby-cart-drawer]');
    if (!shell || !window.EhobbyAovCartDrawer || !window.EhobbyAovCartState || typeof window.HTMLDialogElement?.prototype.showModal !== 'function') return null;
    drawer = new window.EhobbyAovCartDrawer(shell);
    return drawer;
  };
  const open = opener => {
    try {
      const instance = mount();
      if (!instance) return false;
      instance.open();
      if (opener?.isConnected) instance.opener = opener;
      return true;
    } catch { return false; }
  };
  window.EhobbyAovDrawerBridge = { open, mount };
  document.addEventListener('ehobby-aov:added', event => {
    if (event.detail?.drawerHandled) return;
    if (event.target.closest('[data-ehobby-cart-drawer]')) return;
    open(event.target.querySelector('button[type="submit"]'));
  });
  document.addEventListener('shopify:section:load', mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ehobby-aov-engine"] && !Shopify.designMode) return;
  try {
    if (!window.EhobbyAovDiscovery) {
    const responseCache = new Map();
    const relevantPrefixes = ['Platform_', 'Originating-Armory_', 'Power-Source_', 'Replica-Type_', 'Magazine-Type_', 'Accessory-Type_', 'Part-Type_', 'Ammo-Size_'];
    const blockedFamilies = new Set(['hi-capa', '1911', 'p320-m17-m18', '92f-m9-93r', '223-226-228-229']);
    function createCompatibilityGroups(registry) {
      const skuKey = value => typeof value === 'string' ? value.toUpperCase().replace(/[\s-]/g, '') : '';
      const groupSkus = (group, source) => {
        const native = source ? group.manufacturerSourceSkus : group.manufacturerCandidateSkus;
        const merchant = source ? group.merchantSourceSkus : group.merchantCandidateSkus;
        return [...(native || []), ...(group.merchantIdentitySources?.length ? merchant || [] : [])];
      };
      const role = product => {
        const tags = product?.tags || [];
        if (!Array.isArray(tags) || !tags.every(tag => typeof tag === 'string')) return null;
        if (tags.some(tag => ['Internal Parts', 'Magazine-Type_Magazine Accessories'].includes(tag) || tag.startsWith('Part-Type_'))) return null;
        if (tags.some(tag => ['External Parts', 'Airsoft Accessories'].includes(tag) || tag.startsWith('Accessory-Type_'))) {
          if (tags.includes('Airsoft Guns') || tags.includes('Airsoft Magazine')) return null;
          return 'external';
        }
        if (tags.includes('Airsoft Guns') && !tags.includes('Airsoft Magazine')) return 'gun';
        if (tags.includes('Airsoft Magazine') && !tags.includes('Airsoft Guns')) return 'magazine';
        if (tags.some(tag => ['Airsoft Guns', 'Airsoft Magazine', 'Airsoft Accessories', 'Internal Parts', 'External Parts', 'Bb'].includes(tag) || tag.startsWith('Accessory-Type_'))) return null;
        if (!Array.isArray(product?.variants) || !product.variants.length || product.variants.length > 50) return null;
        const roles = new Set();
        for (const group of groups) {
          if (!matchesIdentity(product, group)) continue;
          for (const [expectedRole, skus] of [[group.sourceRole, groupSkus(group, true)], [group.candidateRole, groupSkus(group, false)]]) {
            const accepted = new Set(skus.map(skuKey));
            if (product.variants.every(variant => /^[1-9]\d*$/.test(String(variant.id)) && accepted.has(skuKey(variant.sku)))) roles.add(expectedRole);
          }
        }
        return roles.size === 1 ? [...roles][0] : null;
      };
      const groups = (registry?.groups || []).filter(group => group.id && group.vendor && group.platform && group.sources?.length && groupSkus(group, true).length && groupSkus(group, false).length);
      const matchesIdentity = (product, group) => {
        if (product?.vendor !== group.vendor || !Array.isArray(product.tags) || !product.tags.every(tag => typeof tag === 'string')) return false;
        const tags = [...product.tags];
        for (const proof of group.identityDefaults || []) {
          if (!proof.sources?.length || !proof.skus?.length || !proof.requiredTags?.length
            || !proof.requiredTags.every(tag => tags.includes(tag))
            || !Array.isArray(product.variants) || !product.variants.length || product.variants.length > 50) continue;
          const approved = new Set(proof.skus.map(skuKey));
          if (!product.variants.every(variant => /^[1-9]\d*$/.test(String(variant.id)) && approved.has(skuKey(variant.sku)))) continue;
          for (const tag of proof.tags || []) {
            const prefix = tag.startsWith('Platform_') ? 'Platform_' : tag.startsWith('Power-Source_') ? 'Power-Source_' : null;
            if (prefix && !tags.some(existing => existing.startsWith(prefix))) tags.push(tag);
          }
        }
        const platforms = tags.filter(tag => tag.startsWith('Platform_'));
        if (platforms.length !== 1 || platforms[0] !== `Platform_${group.platform}`) return false;
        if (!['ELECTRIC (AEG)', 'SPRING COCKING', 'GAS'].includes(group.platform)) return false;
        if (/\b(?:HPA|CO2|high[ -]?cap|converted|conversion|modified)\b/i.test(product.title || '')) return false;
        const external = !tags.includes('Airsoft Guns') && !tags.includes('Airsoft Magazine')
          && tags.some(tag => ['External Parts', 'Airsoft Accessories'].includes(tag) || tag.startsWith('Accessory-Type_'));
        if (external) {
          const kinds = tags.filter(tag => tag.startsWith('Accessory-Type_')).map(tag => tag.slice('Accessory-Type_'.length));
          if (group.optional !== true || !group.need || !group.allowedAccessoryTypes?.length || !kinds.length
            || !kinds.every(kind => group.allowedAccessoryTypes.includes(kind))
            || ![group.sourceRole, group.candidateRole].includes('external')) return false;
        }
        if (group.platform === 'GAS') {
          if (/\b(?:AEG|AEP|spring)\b/i.test(product.title || '')) return false;
          const power = tags.filter(tag => tag.startsWith('Power-Source_'));
          const magazines = tags.filter(tag => tag.startsWith('Magazine-Type_'));
          if (power.length !== 1 || !['Power-Source_Green Gas / Top Gas', 'Power-Source_Green Gas', 'Power-Source_Top Gas'].includes(power[0])) return false;
          if (external ? magazines.length !== 0 : magazines.length !== 1 || !['Magazine-Type_Gas Pistols', 'Magazine-Type_Gas Rifles'].includes(magazines[0])) return false;
        } else {
          if (/\bGBB\b/i.test(product.title || '')) return false;
          if (tags.some(tag => /^(?:Power-Source_|Magazine-Type_).*(?:gas|hpa|co2|high[ -]?cap)/i.test(tag))) return false;
        }
        return true;
      };
      const matchesProfile = (product, group, expectedRole) => matchesIdentity(product, group) && role(product) === expectedRole;
      const eligibleVariants = (product, skus, requireAvailable) => {
        const accepted = new Set(skus.map(skuKey));
        return (product?.variants || []).filter(variant => /^\d+$/.test(String(variant.id)) && accepted.has(skuKey(variant.sku)) && (!requireAvailable || variant.available === true));
      };
      const memberships = (product, selectedVariantId) => groups.flatMap(group => {
        const results = [];
        for (const reverse of [false, true]) {
          const expectedRole = reverse ? group.candidateRole : group.sourceRole;
          const skus = groupSkus(group, !reverse);
          if (!matchesProfile(product, group, expectedRole)) continue;
          let variants = eligibleVariants(product, skus, false);
          if (selectedVariantId != null) variants = variants.filter(variant => String(variant.id) === String(selectedVariantId));
          if (variants.length) results.push({ group, reverse, sourceVariantIds: variants.map(variant => String(variant.id)) });
        }
        return results;
      });
      const match = (source, candidate, { selectedVariantId, inCartVariantIds = [] } = {}) => {
        if (!candidate || candidate.available !== true || (source?.handle && source.handle === candidate.handle)) return [];
        const inCart = new Set(inCartVariantIds.map(String));
        return memberships(source, selectedVariantId).flatMap(({ group, reverse }) => {
          const expectedRole = reverse ? group.sourceRole : group.candidateRole;
          if (!matchesProfile(candidate, group, expectedRole)) return [];
          const skus = groupSkus(group, reverse);
          const variantIds = eligibleVariants(candidate, skus, true).map(variant => String(variant.id)).filter(id => !inCart.has(id));
          return variantIds.length ? [{ groupId: group.id, variantIds, direction: reverse ? `${group.candidateRole}-to-${group.sourceRole}` : `${group.sourceRole}-to-${group.candidateRole}` }] : [];
        });
      };
      return { memberships, match, role };
    }
    const verifiedGroups = createCompatibilityGroups({"groups":[{"id":"silverback-micron-v3-aeg-oem-ar15-magazine","vendor":"Silverback","sourceRole":"gun","candidateRole":"magazine","platform":"ELECTRIC (AEG)","manufacturerSourceSkus":["SBA-AEG-04BK","SBA-AEG-04BKFDE","SBA-AEG-04FDE"],"manufacturerCandidateSkus":["SBA-MAG-51BK","SBA-MAG-51FDE"],"sources":[{"url":"https://www.silverback-airsoft.com/aeg-04","supports":"Micron V3 AEG source SKUs, included 120-round AR15/5.56 magazine and third-party compatibility caveat"},{"url":"https://www.silverback-airsoft.com/mag-51","supports":"MDRX/AR15 120-round OEM magazine SKUs and colors"},{"url":"https://www.silverback-airsoft.com/mag-50","supports":"Separate MDRX/AR10 78-round product; not evidence for Micron fit"}],"sourceQuery":"Silverback MDRX Micron","candidateQuery":"Silverback MDRX AR15 magazine"},{"id":"silverback-tac41-lite-a2-oem-short-magazine","vendor":"Silverback","sourceRole":"gun","candidateRole":"magazine","platform":"SPRING COCKING","manufacturerSourceSkus":["SBA-T41LR-FDE","SBA-T41LL-OD","SBA-T41LL-FDE","SBA-T41LA-BK","SBA-T41LA-FDE","SBA-T41LA-OD","SBA-T41LB-BK","SBA-T41LB-OD","SBA-T41LB-FDE","SBA-T41AB-FDE","SBA-T41AL-BK","SBA-T41AL-OD","SBA-T41AL-FDE"],"manufacturerCandidateSkus":["SBA-MAG-30"],"sources":[{"url":"https://www.silverback-airsoft.com/t41l","supports":"TAC41 Lite chassis stock options and48-round magazine system; storeSKU mapping for LA/LB/LR/LL variants."},{"url":"https://www.silverback-airsoft.com/tac41aa","supports":"TAC41 A2 chassis stock variants AB/AL with corresponding manufacturerSKU/image references."},{"url":"https://www.silverback-airsoft.com/mag-30","supports":"Manufacturer TAC41 short48-round magazine identity SBA-MAG-30. Family compatibility applied only to verified OEM stock replicas, not conversions."}],"sourceQuery":"Silverback TAC 41","candidateQuery":"Silverback TAC41 48rds magazine"},{"id":"action-army-aap01-original-gas-magazine","vendor":"Action Army","sourceRole":"gun","candidateRole":"magazine","platform":"GAS","merchantSourceSkus":["AATW-PS-AAP01-BK"],"merchantCandidateSkus":["U01-001","U01-021"],"merchantIdentitySources":["https://www.ehobbyasia.com/products/action-army-aap-01-assassin-gbb-pistol","https://www.ehobbyasia.com/products/action-army-aap-01-22rds-gas-magazine","https://www.ehobbyasia.com/products/action-army-lightweight-50rds-gas-magazine-for-aap-01-marui-g18c-gbb"],"sources":[{"url":"https://www.ehobbyasia.com/products/action-army-lightweight-50rds-gas-magazine-for-aap-01-marui-g18c-gbb","supports":"Current merchant U01-021 identity and explicit original AAP01 gas pistol fitment; no broad Marui-family registration"},{"url":"https://actionsportgames.com/action-army-aap-01-extended-magazine-gas-50-rds-19771","supports":"Supplier corroboration for AAP01 50-round gas magazine model compatibility; not merchantSKU-to-ASG19771 equivalence"},{"url":"https://actionsportgames.com/action-army-aap-01-gas-black-20130","supports":"AAP01 standard gas magazine pairing, not merchant-to-ASG SKU equivalence"},{"url":"https://www.ehobbyasia.com/products/action-army-aap-01-22rds-gas-magazine","supports":"Merchant original22rd gas magazine direct Assassin-series fitment and SKU identity"}],"identityDefaults":[{"skus":["U01-001"],"requiredTags":["Airsoft Magazine","Airsoft Pistol Magazine","Magazine-Type_Gas Pistols","Ammo-Size_6mm"],"tags":["Platform_GAS","Power-Source_Green Gas / Top Gas"],"sources":["aap01-identity-decision-20260910.json"]}],"sourceQuery":"Action Army AAP01 Assassin","candidateQuery":"Action Army AAP01 gas magazine"},{"id":"action-army-aap01-original-optional-rear-mount","vendor":"Action Army","sourceRole":"gun","candidateRole":"external","platform":"GAS","merchantSourceSkus":["AATW-PS-AAP01-BK"],"merchantCandidateSkus":["AATW-U01-006"],"merchantIdentitySources":["https://www.ehobbyasia.com/products/action-army-aap-01-assassin-gbb-pistol","https://www.ehobbyasia.com/products/action-army-aap-01-rear-mount"],"sources":[{"url":"https://www.ehobbyasia.com/products/action-army-aap-01-rear-mount","supports":"Merchant SKU identity and explicit rear rail fitment for original Action Army AAP01 GBB pistol; not every optic or joint-installation assurance"}],"optional":true,"need":"rear-mount","allowedAccessoryTypes":["Rail Mount"],"conflictTags":["Accessory-Type_Buttstock","Accessory-Type_Rail Mount","Accessory-Type_Slide"],"sourceQuery":"Action Army AAP01 Assassin","candidateQuery":"Action Army AAP01 Rear Mount"}]});
    const handleize = value => String(value || '').normalize('NFKD').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const words = value => String(value || '').normalize('NFKD').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const tokensFor = element => String(element?.dataset.aovProfile || '').split('|').map(token => token.replaceAll('_', '-')).filter(Boolean);
    const valuesFor = (tokens, prefix) => tokens.filter(token => token.startsWith(prefix)).map(token => token.slice(prefix.length));
    const overlap = (left, right) => left.some(value => right.includes(value));
    const tagsFor = product => Array.isArray(product?.identity?.tags) ? product.identity.tags : Array.isArray(product?.tags) ? product.tags : [];
    const tagValuesFor = (product, prefix) => tagsFor(product).filter(tag => tag.startsWith(prefix)).map(tag => handleize(tag.slice(prefix.length))).filter(Boolean);
    const profileFor = product => {
      const tokens = [`vendor:${handleize(product.vendor)}`, `type:${handleize(product.type || product.product_type)}`];
      for (const tag of product.tags || []) {
        if (relevantPrefixes.some(prefix => String(tag).startsWith(prefix))) tokens.push(handleize(tag));
      }
      return [...new Set(tokens)].filter(Boolean);
    };
    const roleFor = product => {
      const tags = product.tags || [];
      const title = String(product.title || '');
      const verifiedRole = verifiedGroups.role(product);
      if (verifiedRole) return verifiedRole;
      if (tags.includes('Airsoft Magazine')) return 'magazine';
      if (tags.includes('Bb') && /\b(?:bbs?|b\.b\.)\b/i.test(title) && !/battery|charger|gas|loader|loading\s*tool|speed\s*loader|bottle|container|grenade/i.test(title)) return 'bb';
      if (tags.includes('Internal Parts') || tags.some(tag => tag.startsWith('Part-Type_'))) return 'internal';
      if ((tags.includes('Airsoft Accessories') || tags.includes('External Parts')) && !tags.includes('Internal Parts')) return 'external';
      if (tags.includes('Red Dot Sight') || tags.includes('Rifle Scope')) return 'optic';
      if (['Airsoft Guns', 'Airsoft Pistols', 'Airsoft Rifles', 'Airsoft Snipers', 'Airsoft Shotguns', 'Airsoft Machine Guns', 'Airsoft Grenade Launchers', 'Airsoft Spring Pistols', 'Cheap Airsoft Guns'].some(tag => tags.includes(tag))) return 'gun';
      return 'other';
    };
    const readSourceIdentity = element => {
      try {
        const identity = JSON.parse(element.dataset.aovIdentity || 'null');
        if (!identity || typeof identity.vendor !== 'string' || !Array.isArray(identity.tags) || !identity.tags.every(tag => typeof tag === 'string')) return null;
        if (!Array.isArray(identity.variants) || identity.variants.length !== identity.variantCount || identity.variants.length > 50) return null;
        if (!identity.variants.every(variant => /^\d+$/.test(variant.id) && typeof variant.sku === 'string')) return null;
        if (!Array.isArray(identity.selectedVariantIds) || !identity.selectedVariantIds.length || !identity.selectedVariantIds.every(id => identity.variants.some(variant => variant.id === id))) return null;
        return identity;
      } catch { return null; }
    };
    const sourceFrom = element => {
      const identity = readSourceIdentity(element);
      return {
      handle: element.dataset.aovHandle,
      title: element.dataset.aovTitle,
      type: element.dataset.aovType,
      role: identity && verifiedGroups.role({ title: element.dataset.aovTitle, ...identity }) || element.dataset.aovRole,
      price: Number(element.dataset.aovPrice) || 0,
      tokens: tokensFor(element),
      identity
      };
    };
    const isSpecificFamily = value => {
      const family = handleize(value);
      if (!family || family.length < 3 || blockedFamilies.has(family)) return false;
      return !/(?:^|-)(?:series|fits|other|platform|custom|ww1|ww2)(?:-|$)/.test(family) && !/[&/]/.test(String(value));
    };
    const identityProduct = source => ({ handle: source.handle, title: source.title, ...source.identity });
    const groupMemberships = source => {
      if (!source.identity?.variants?.length) return [];
      const product = identityProduct(source);
      return verifiedGroups.memberships(product).filter(membership => source.identity.variants.every(variant => membership.sourceVariantIds.includes(String(variant.id))));
    };
    const groupVariantIds = (source, product) => {
      const memberships = groupMemberships(source);
      if (!memberships.length) return [];
      return [...new Set(verifiedGroups.match(identityProduct(source), product).filter(match => memberships.some(membership => membership.group.id === match.groupId)).flatMap(match => match.variantIds))];
    };
    const titleContainsFamily = (title, family) => {
      const titleWords = ` ${words(title)} `;
      const familyWords = words(family);
      return Boolean(familyWords) && new RegExp(` ${familyWords.split(' ').join(' *')} `).test(titleWords);
    };
    const reverseModelCompatible = (sourceTitle, candidateTitle) => {
      const sourceWords = words(sourceTitle);
      const candidateWords = words(candidateTitle);
      const generations = value => [...value.matchAll(/\bgen\s*(\d+)\b/g)].map(match => match[1]);
      const modelNumbers = value => value.replace(/\bgen\s*\d+\b/g, ' ').split(' ').filter(token => token.length >= 2 && /\d/.test(token));
      const sourceGenerations = generations(sourceWords);
      const candidateGenerations = generations(candidateWords);
      if (sourceGenerations.length && candidateGenerations.length && !overlap(sourceGenerations, candidateGenerations)) return false;
      const sourceModels = modelNumbers(sourceWords);
      const candidateModels = modelNumbers(candidateWords);
      return !sourceModels.length || !candidateModels.length || overlap(sourceModels, candidateModels);
    };
    const strictCompatibility = (source, product, mode) => {
      const candidateRole = roleFor(product);
      const candidateTokens = profileFor(product);
      if (mode === 'ammo') {
        return source.role === 'gun' && candidateRole === 'bb' && valuesFor(source.tokens, 'ammo-size-').includes('6mm') && valuesFor(candidateTokens, 'ammo-size-').includes('6mm');
      }
      if (source.identity && groupMemberships(source).length) return groupVariantIds(source, product).length > 0;
      if (!isSpecificFamily(source.type) || handleize(product.type || product.product_type) !== handleize(source.type)) return false;
      if (!titleContainsFamily(product.title, source.type)) return false;
      if (source.role === 'gun' && candidateRole !== 'magazine') return false;
      if (source.role === 'magazine' && candidateRole !== 'gun') return false;
      if (source.role !== 'gun' && source.role !== 'magazine') return false;
      if (!valuesFor(source.tokens, 'vendor:').includes(handleize(product.vendor))) return false;
      const sourcePlatforms = valuesFor(source.tokens, 'platform-');
      const candidatePlatforms = valuesFor(candidateTokens, 'platform-');
      const sourceArmories = valuesFor(source.tokens, 'originating-armory-');
      const candidateArmories = valuesFor(candidateTokens, 'originating-armory-');
      const sourceMagazines = valuesFor(source.tokens, 'magazine-type-');
      const candidateMagazines = valuesFor(candidateTokens, 'magazine-type-');
      if (!overlap(sourcePlatforms, candidatePlatforms) || !overlap(sourceArmories, candidateArmories)) return false;
      if (!sourceMagazines.length || !candidateMagazines.length || !overlap(sourceMagazines, candidateMagazines)) return false;
      const sourcePower = valuesFor(source.tokens, 'power-source-');
      const candidatePower = valuesFor(candidateTokens, 'power-source-');
      if (sourcePower.length && candidatePower.length && !overlap(sourcePower, candidatePower)) return false;
      return true;
    };
    const preliminaryCompatibility = (source, product, mode) => {
      if (!product?.available || product.handle === source.handle || words(product.title) === words(source.title)) return false;
      if (mode === 'related') return nativeCompatibility(source, product, mode);
      if (mode === 'exact' && source.identity && groupMemberships(source).length) {
        return groupMemberships(source).some(({ group, reverse }) => product.vendor === group.vendor && (roleFor(product) === (reverse ? group.sourceRole : group.candidateRole) || roleFor(product) === 'other'));
      }
      return strictCompatibility(source, { ...product, type: source.type }, mode);
    };
    const nativeCompatibility = (source, product, mode) => {
      if (!product?.available || product.handle === source.handle || words(product.title) === words(source.title)) return false;
      const candidateRole = roleFor(product);
      if (mode !== 'related' && ((source.role === 'gun' && candidateRole === 'magazine') || (source.role === 'magazine' && candidateRole === 'gun'))) {
        return strictCompatibility(source, product, 'exact');
      }
      if (source.role === 'gun' && candidateRole === 'bb') return strictCompatibility(source, product, 'ammo');
      if (mode === 'complementary') return false;
      if (mode !== 'related') return false;
      const candidateTokens = profileFor(product);
      const sameType = Boolean(handleize(source.type)) && handleize(source.type) === handleize(product.type || product.product_type);
      const sourcePlatforms = valuesFor(source.tokens, 'platform-');
      const candidatePlatforms = valuesFor(candidateTokens, 'platform-');
      const sourceArmories = valuesFor(source.tokens, 'originating-armory-');
      const candidateArmories = valuesFor(candidateTokens, 'originating-armory-');
      if (candidateRole === 'gun' && ['bb', 'optic', 'magazine', 'external', 'internal'].includes(source.role)) {
        if (source.role === 'bb') return valuesFor(source.tokens, 'ammo-size-').includes('6mm') && valuesFor(candidateTokens, 'ammo-size-').includes('6mm');
        if (source.role === 'optic') return tagsFor(source).some(tag => ['Red Dot Sight', 'Rifle Scope'].includes(tag)) && valuesFor(candidateTokens, 'ammo-size-').includes('6mm');
        if (source.role === 'internal' && !reverseModelCompatible(source.title, product.title)) return false;
        return sameType && sourcePlatforms.length > 0 && candidatePlatforms.length > 0 && overlap(sourcePlatforms, candidatePlatforms)
          && sourceArmories.length > 0 && candidateArmories.length > 0 && overlap(sourceArmories, candidateArmories);
      }
      if (source.role !== candidateRole) return false;
      if (source.role === 'gun') return sameType;
      if (source.role === 'magazine') return sameType && isSpecificFamily(source.type) && titleContainsFamily(product.title, source.type);
      if (source.role === 'bb') return overlap(valuesFor(source.tokens, 'ammo-size-'), valuesFor(candidateTokens, 'ammo-size-'));
      if (source.role === 'optic') {
        const sourceOptics = tagsFor(source).filter(tag => ['Red Dot Sight', 'Rifle Scope'].includes(tag));
        const candidateOptics = tagsFor(product).filter(tag => ['Red Dot Sight', 'Rifle Scope'].includes(tag));
        return sourceOptics.length > 0 && overlap(sourceOptics, candidateOptics);
      }
      if (source.role === 'internal') {
        const sourceParts = tagValuesFor(source, 'Part-Type_');
        const candidateParts = tagValuesFor(product, 'Part-Type_');
        if (!sourceParts.length || !candidateParts.length || !overlap(sourceParts, candidateParts)) return false;
        return !sourcePlatforms.length || !candidatePlatforms.length || overlap(sourcePlatforms, candidatePlatforms);
      }
      if (source.role !== 'external') return false;
      const sourceAccessories = valuesFor(source.tokens, 'accessory-type-');
      const candidateAccessories = valuesFor(candidateTokens, 'accessory-type-');
      if (!sourceAccessories.length || !candidateAccessories.length || !overlap(sourceAccessories, candidateAccessories)) return false;
      return true;
    };
    const compatibleFor = item => item.mode === 'exact' || item.mode === 'ammo'
      ? strictCompatibility(item.source, item.full, item.mode)
      : nativeCompatibility(item.source, item.full, item.mode);
    const confidenceFor = mode => mode === 'exact' ? 95 : mode === 'complementary' ? 80 : mode === 'ammo' ? 75 : 55;
    let discoveryReadNotBefore = 0;
    const readLimitError = response => {
      const error = new Error(`Request failed: ${response.status}`);
      error.retryAfter = response.headers?.get?.('Retry-After');
      if (response.status === 429) {
        const value = String(error.retryAfter || '').trim();
        const delay = /^\d+(?:\.\d+)?$/.test(value) ? Number(value) * 1000 : Date.parse(value) - Date.now();
        discoveryReadNotBefore = Math.max(discoveryReadNotBefore, Date.now() + (Number.isFinite(delay) && delay > 0 ? delay : 30000));
        error.retryAfter = String(Math.ceil((discoveryReadNotBefore - Date.now()) / 1000));
      }
      return error;
    };
    const assertDiscoveryReadAllowed = () => {
      if (Date.now() >= discoveryReadNotBefore) return;
      const error = new Error('Recommendation reads paused after rate limit');
      error.retryAfter = String(Math.ceil((discoveryReadNotBefore - Date.now()) / 1000));
      throw error;
    };
    const fetchJson = async (url, { fresh = false } = {}) => {
      const key = String(url);
      if (!fresh && responseCache.has(key)) return responseCache.get(key);
      assertDiscoveryReadAllowed();
      const request = (async () => {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 7000);
        try {
          const response = await fetch(url, {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' },
            cache: fresh ? 'no-store' : 'default',
            signal: controller.signal
          });
          if (!response.ok) {
            throw readLimitError(response);
          }
          return await response.json();
        } finally {
          clearTimeout(timer);
        }
      })();
      responseCache.set(key, request);
      try {
        return await request;
      } catch (error) {
        if (responseCache.get(key) === request) responseCache.delete(key);
        throw error;
      }
    };
    const fetchText = async url => {
      assertDiscoveryReadAllowed();
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 7000);
      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          cache: 'no-store',
          signal: controller.signal
        });
        if (!response.ok) {
          throw readLimitError(response);
        }
        return await response.text();
      } finally {
        clearTimeout(timer);
      }
    };
    const search = async (section, query) => {
      const url = new URL(section.dataset.aovSearchUrl, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');
      const body = await fetchJson(url);
      return body?.resources?.results?.products || [];
    };
    const loadProduct = async (result, fresh = false) => {
      const url = new URL(result.url || `/products/${encodeURIComponent(result.handle)}`, location.origin);
      if (url.origin !== location.origin) throw new Error('Unexpected product origin');
      url.search = '';
      url.hash = '';
      url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      const product = await fetchJson(url, { fresh });
      product._aovUrl = url.pathname.replace(/\.js$/, '');
      return product;
    };
    const mapLimit = async (items, limit, worker) => {
      const results = new Array(items.length);
      let cursor = 0;
      const runners = Array.from({ length: Math.min(limit, items.length) }, async () => {
        while (cursor < items.length) {
          const index = cursor++;
          try { results[index] = await worker(items[index], index); }
          catch { results[index] = null; }
        }
      });
      await Promise.all(runners);
      return results.filter(Boolean);
    };
    const element = (name, className, text) => {
      const node = document.createElement(name);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const currency = () => window.Shopify?.currency?.active || 'USD';
    const formatMoney = cents => {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency() }).format(Number(cents) / 100); }
      catch { return `${(Number(cents) / 100).toFixed(2)} ${currency()}`; }
    };
    const addHiddenInput = (form, name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = String(value);
      form.append(input);
      return input;
    };
    const renderCard = (section, product, source, reason, confidence, position, need, strategy, optional = false) => {
      const availableVariants = (product.variants || []).filter(variant => variant.available);
      if (!availableVariants.length) return null;
      const firstVariant = availableVariants[0];
      const card = element('article', 'ehobby-aov__card');
      card.setAttribute('role', 'listitem');
      card.hidden = true;
      card.dataset.aovProduct = String(product.id);
      card.dataset.aovHandle = product.handle;
      card.dataset.aovSource = section.dataset.aovPlacement;
      card.dataset.aovOrigin = source.handle;
      card.dataset.aovOriginPrice = String(source.price || 0);
      card.dataset.aovRole = roleFor(product);
      card.dataset.aovNeed = need;
      card.dataset.aovOptional = String(optional);
      card.dataset.aovStrategy = strategy;
      card.dataset.aovConfidence = String(confidence);
      card.dataset.aovPosition = String(position);
      card.dataset.aovPrice = String(firstVariant.price);
      card.dataset.aovProfile = profileFor(product).join('|');
      card._aovProductTags = Array.isArray(product.tags) && product.tags.every(tag => typeof tag === 'string') ? [...product.tags] : null;
      const compareAtPrice = Number(firstVariant.compare_at_price) || 0;
      const savings = Math.max(0, compareAtPrice - Number(firstVariant.price));
      card.dataset.aovCompareAt = String(compareAtPrice);
      card.dataset.aovSavings = String(savings);
      card.dataset.aovSale = String(compareAtPrice > Number(firstVariant.price) ? Math.round((savings / compareAtPrice) * 100) : 0);

      const productUrl = product._aovUrl || `/products/${encodeURIComponent(product.handle)}`;
      const media = element('a', 'ehobby-aov__media');
      media.href = productUrl;
      const image = element('img', 'ehobby-aov__image');
      image.loading = 'lazy';
      image.decoding = 'async';
      image.alt = product.title;
      image.width = 220;
      image.height = 160;
      image.src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.src || product.images?.[0] || '';
      media.append(image);
      card.append(media);

      const details = element('div', 'ehobby-aov__details');
      details.append(element('p', 'ehobby-aov__reason', reason));
      const title = element('h3', 'ehobby-aov__product-title');
      const titleLink = element('a', '', product.title);
      titleLink.href = productUrl;
      title.append(titleLink);
      details.append(title);

      if (strategy === 'related') {
        details.append(element('div', 'ehobby-aov__price money', formatMoney(firstVariant.price)));
        const view = element('a', 'button-primary ehobby-aov__button', section.dataset.aovViewOptions);
        view.href = productUrl;
        details.append(view);
        card.append(details);
        return card;
      }

      if (product.requires_selling_plan || product.gift_card || availableVariants.length > 50) {
        const view = element('a', 'button-primary ehobby-aov__button', section.dataset.aovViewOptions);
        view.href = productUrl;
        details.append(view);
        card.append(details);
        return card;
      }

      const wrapper = element('ehobby-aov-form');
      wrapper.dataset.page = section.dataset.aovPlacement;
      wrapper.dataset.cartUrl = section.dataset.aovCartUrl;
      wrapper.dataset.loading = section.dataset.aovLoading;
      wrapper.dataset.success = section.dataset.aovSuccess;
      wrapper.dataset.addedShort = section.dataset.aovAddedShort;
      wrapper.dataset.uncertain = section.dataset.aovUncertain;
      wrapper.dataset.refresh = section.dataset.aovRefresh;
      const form = element('form', 'ehobby-aov__form');
      form.method = 'post';
      form.action = section.dataset.aovCartAddUrl;
      const price = element('div', 'ehobby-aov__price money');
      if (compareAtPrice > Number(firstVariant.price)) {
        price.append(element('s', 'ehobby-aov__compare-price', formatMoney(compareAtPrice)), document.createTextNode(' '));
      }
      price.append(element('span', 'ehobby-aov__current-price', formatMoney(firstVariant.price)));
      form.append(price);

      let variantSelect = null;
      if (availableVariants.length === 1) {
        addHiddenInput(form, 'id', firstVariant.id);
        addHiddenInput(form, 'quantity', 1);
      } else {
        const selectId = `ehobby-aov-dynamic-${section.id || 'section'}-${product.id}`;
        const label = element('label', '', section.dataset.aovChoose);
        label.htmlFor = selectId;
        variantSelect = element('select', 'ehobby-aov__variant');
        variantSelect.id = selectId;
        variantSelect.name = 'id';
        variantSelect.required = true;
        const placeholder = element('option', '', section.dataset.aovChoose);
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.selected = true;
        variantSelect.append(placeholder);
        for (const variant of availableVariants) {
          const option = element('option', '', `${variant.title} — ${formatMoney(variant.price)}`);
          option.value = String(variant.id);
          option.dataset.min = '1';
          option.dataset.price = String(variant.price);
          option.dataset.savings = String(Math.max(0, (Number(variant.compare_at_price) || 0) - Number(variant.price)));
          variantSelect.append(option);
        }
        form.append(label, variantSelect);
        addHiddenInput(form, 'quantity', 1);
      }
      const button = element('button', 'button-primary ehobby-aov__button', section.dataset.aovAdd);
      button.type = 'submit';
      button.name = 'add';
      button.setAttribute('aria-label', `${section.dataset.aovAdd}: ${product.title}`);
      form.append(button);
      wrapper.append(form);

      const selectLabel = element('label', 'ehobby-aov__select-label');
      const checkbox = document.createElement('input');
      checkbox.className = 'ehobby-aov__select';
      checkbox.type = 'checkbox';
      checkbox.setAttribute('data-aov-select', '');
      checkbox.dataset.aovVariant = availableVariants.length === 1 ? String(firstVariant.id) : '';
      checkbox.dataset.aovQuantity = '1';
      checkbox.dataset.aovUnitPrice = String(firstVariant.price);
      checkbox.dataset.aovUnitSavings = String(savings);
      checkbox.checked = availableVariants.length === 1;
      checkbox.disabled = availableVariants.length !== 1;
      checkbox.setAttribute('aria-label', `${section.dataset.aovInclude}: ${product.title}`);
      selectLabel.append(checkbox, element('span', '', section.dataset.aovInclude));
      wrapper.append(selectLabel);
      wrapper.append(element('p', 'ehobby-aov__status'));
      wrapper.lastElementChild.setAttribute('role', 'status');
      wrapper.lastElementChild.setAttribute('aria-live', 'polite');
      wrapper.lastElementChild.setAttribute('aria-atomic', 'true');
      const cartLink = element('a', 'ehobby-aov__cart-link', section.dataset.aovViewCart);
      cartLink.href = section.dataset.aovCartUrl;
      cartLink.hidden = true;
      wrapper.append(cartLink);
      details.append(wrapper);
      card.append(details);
      return card;
    };
    const roundRobinSources = inputs => {
      const groups = new Map();
      for (const input of inputs) {
        const key = input.source.handle;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(input);
      }
      const ordered = [];
      const rows = [...groups.values()];
      for (let index = 0; rows.some(row => index < row.length); index++) {
        for (const row of rows) if (row[index]) ordered.push(row[index]);
      }
      return ordered;
    };
    const recordDiscoveryFailure = (section, error) => {
      section._aovDiscoveryFailures = (section._aovDiscoveryFailures || 0) + 1;
      const retryAfter = error?.retryAfter;
      const delay = /^\d+(?:\.\d+)?$/.test(String(retryAfter)) ? Number(retryAfter) * 1000 : Date.parse(retryAfter) - Date.now();
      if (Number.isFinite(delay) && delay > 0) section._aovRecoveryDelay = Math.max(section._aovRecoveryDelay || 1500, delay);
    };
    const candidateGroupsFor = (inputs, excluded, limit = 24) => {
      const groups = new Map();
      for (const input of roundRobinSources(inputs)) {
        const handle = input.product?.handle;
        if (!handle || excluded.has(handle)) continue;
        if (!groups.has(handle)) {
          if (groups.size >= limit) continue;
          groups.set(handle, { product: input.product, matches: [] });
        }
        const group = groups.get(handle);
        if (!group.matches.some(match => match.source.handle === input.source.handle && match.mode === input.mode)) group.matches.push(input);
      }
      return [...groups.values()];
    };
    const bestCompatibleMatch = (group, full) => {
      if (!full?.available || full.handle !== group.product.handle) return null;
      const matches = group.matches.map(input => ({ ...input, full })).filter(compatibleFor);
      matches.sort((a, b) => confidenceFor(b.mode) - confidenceFor(a.mode));
      const best = matches[0];
      if (!best) return null;
      const candidateRole = roleFor(full);
      if (best.source.role === 'gun' && candidateRole === 'bb') best.mode = 'ammo';
      if ((best.source.role === 'gun' && candidateRole === 'magazine') || (best.source.role === 'magazine' && candidateRole === 'gun')) best.mode = 'exact';
      if (best.mode !== 'related' && ['gun', 'magazine', 'external'].includes(roleFor(full)) && best.source.identity && groupMemberships(best.source).length) {
        const eligibleIds = new Set(groupVariantIds(best.source, full));
        best.full = { ...full, variants: full.variants.filter(variant => eligibleIds.has(String(variant.id))) };
        const matchedGroups = verifiedGroups.match(identityProduct(best.source), full);
        const optional = groupMemberships(best.source).find(({ group }) => group.optional === true
          && matchedGroups.some(match => match.groupId === group.id));
        if (optional) {
          best.optional = true;
          best.optionalConflictTags = optional.group.conflictTags;
          best.optionalPair = { groupId: optional.group.id, sourceHandle: best.source.handle,
            sourceVariantIds: [...best.source.identity.selectedVariantIds], candidateHandle: full.handle,
            candidateId: full.id, candidateVariantIds: best.full.variants.map(variant => String(variant.id)) };
          best.optionalSource = optional.reverse && best.source.role === 'external' && candidateRole === 'gun'
            ? { handle: best.source.handle, groupId: optional.group.id, variantIds: [...best.source.identity.selectedVariantIds] }
            : null;
          best.optionalNeed = `${best.source.handle}:optional:${optional.group.need}`;
        }
      }
      return best;
    };
    const needFor = item => item.optional ? item.optionalNeed : item.mode === 'ammo' ? 'ammo'
      : item.mode === 'exact' ? `${item.source.handle}:exact` : `${item.source.handle}:${item.mode}:${item.full.handle}`;
    const verifyOptionalCandidate = async (policy, variantId) => {
      const pair = policy?.optionalPair;
      if (!pair || !/^[1-9]\d*$/.test(String(variantId)) || !Array.isArray(pair.candidateVariantIds)
        || !pair.candidateVariantIds.includes(String(variantId)) || !Array.isArray(pair.sourceVariantIds)
        || !pair.sourceVariantIds.length || !pair.sourceVariantIds.every(id => /^[1-9]\d*$/.test(String(id)))
        || !Number.isSafeInteger(pair.candidateId) || pair.candidateId < 1) return false;
      try {
        const [source, candidate] = await Promise.all([
          loadProduct({ handle: pair.sourceHandle }, true), loadProduct({ handle: pair.candidateHandle }, true)
        ]);
        if (source?.handle !== pair.sourceHandle || candidate?.handle !== pair.candidateHandle
          || candidate.id !== pair.candidateId || candidate.requires_selling_plan || candidate.gift_card) return false;
        return pair.sourceVariantIds.every(selectedVariantId => verifiedGroups.match(source, candidate, { selectedVariantId })
          .some(match => match.groupId === pair.groupId && match.variantIds.includes(String(variantId))));
      } catch { return false; }
    };
    const isOptionalSource = (policy, product, variantIds) => {
      const source = policy?.optionalSource;
      if (!source || source.handle !== product?.handle || !Array.isArray(source.variantIds)
        || !Array.isArray(variantIds) || !variantIds.length
        || !variantIds.every(id => source.variantIds.includes(String(id)))) return false;
      return verifiedGroups.memberships(product).some(member => member.reverse && member.group.optional === true
        && member.group.id === source.groupId && member.group.candidateRole === 'external'
        && variantIds.every(id => member.sourceVariantIds.includes(String(id))));
    };
    const optionalContextAllowed = (section, item) => {
      if (!item?.optional) return true;
      if (!Array.isArray(item.optionalConflictTags) || !item.optionalConflictTags.length
        || typeof section.dataset.aovCartHandles !== 'string') return false;
      const sources = [...section.querySelectorAll('[data-aov-source-profile]')].map(sourceFrom);
      return section.dataset.aovCartHandles.split('|').filter(Boolean).every(handle => {
        const source = sources.find(source => source.handle === handle);
        if (source?.identity && isOptionalSource(item, identityProduct(source), source.identity.selectedVariantIds)) return true;
        return !!source?.identity && !source.identity.tags.some(tag => item.optionalConflictTags.includes(tag));
      });
    };
    const allowOptionalAdd = (card, cart, pendingCards = [], freshProducts = null) => {
      if (card?.dataset.aovOptional !== 'true') return true;
      const section = card.closest('.ehobby-aov');
      const policy = card._aovOptionalPolicy;
      if (!section || !policy || !Array.isArray(cart?.items) || !Number.isSafeInteger(cart.item_count)
        || cart.item_count < 0 || cart.items.some(item => typeof item.handle !== 'string' || !item.handle
          || !Number.isSafeInteger(item.quantity) || item.quantity < 1)
        || cart.items.reduce((sum, item) => sum + item.quantity, 0) !== cart.item_count) return false;
      if (!Array.isArray(pendingCards) || !pendingCards.every(other => other === card ||
        (Array.isArray(other?._aovProductTags) && other._aovProductTags.every(tag => typeof tag === 'string')
          && Array.isArray(policy.optionalConflictTags)
          && !other._aovProductTags.some(tag => policy.optionalConflictTags.includes(tag))))) return false;
      if (freshProducts !== null) return Array.isArray(policy.optionalConflictTags) && policy.optionalConflictTags.length > 0
        && cart.items.every(item => {
          const product = freshProducts.get(item.handle);
          if (isOptionalSource(policy, product, [String(item.variant_id)])) return true;
          const tags = product?.tags;
          return Array.isArray(tags) && tags.length > 0 && tags.every(tag => typeof tag === 'string')
            && !tags.some(tag => policy.optionalConflictTags.includes(tag));
        });
      return optionalContextAllowed({
        dataset: { aovCartHandles: cart.items.map(item => item.handle).join('|') },
        querySelectorAll: selector => section.querySelectorAll(selector)
      }, policy);
    };
    const checkOptionalAdd = async (card, cart, pendingCards = []) => {
      if (card?.dataset.aovOptional !== 'true') return true;
      const fingerprint = value => {
        const keys = new Set();
        if (!Array.isArray(value?.items) || value.items.length > 50 || !Number.isSafeInteger(value.item_count)
        || value.item_count < 0 || value.items.some(item => {
          if (typeof item?.key !== 'string' || !item.key.trim() || keys.has(item.key)) return true;
          keys.add(item.key);
          return !/^[a-z0-9][a-z0-9-]*$/.test(item.handle || '')
          || !Number.isSafeInteger(item.product_id) || item.product_id < 1
          || !Number.isSafeInteger(item.variant_id) || item.variant_id < 1
          || !Number.isSafeInteger(item.quantity) || item.quantity < 1;
        }) || value.items.reduce((sum,item) => sum + item.quantity,0) !== value.item_count) return null;
        return JSON.stringify(value.items.map(item => [item.key,item.product_id,item.variant_id,item.handle,item.quantity]).sort((a,b) => a[0].localeCompare(b[0])));
      };
      const before = fingerprint(cart);
      if (before === null) return false;
      try {
        const handles = [...new Set(cart.items.map(item => item.handle))];
        const products = await mapLimit(handles, 3, async handle => {
          const product = await loadProduct({ handle }, true);
          if (product?.handle !== handle || !Array.isArray(product.tags) || !product.tags.length
            || !product.tags.every(tag => typeof tag === 'string') || !Array.isArray(product.variants)
            || !cart.items.filter(item => item.handle === handle).every(item => product.id === item.product_id
              && product.variants.some(variant => variant.id === item.variant_id))) throw new Error('Product identity unavailable');
          return product;
        });
        if (!allowOptionalAdd(card, cart, pendingCards, new Map(products.map(product => [product.handle, product])))) return false;
        const cartUrl = new URL(card.closest('.ehobby-aov')?.dataset.aovCartUrl || `${window.Shopify?.routes?.root || '/'}cart`, location.origin);
        if (cartUrl.origin !== location.origin) return false;
        cartUrl.pathname = cartUrl.pathname.replace(/\/$/, '') + '.js';
        cartUrl.search = '';
        cartUrl.hash = '';
        return fingerprint(await fetchJson(cartUrl, { fresh: true })) === before;
      } catch { return false; }
    };
    const checkOptionalSubmission = async (card, cart, pendingCards, variantId) => {
      if (card?.dataset.aovOptional !== 'true') return true;
      if (!await verifyOptionalCandidate(card._aovOptionalPolicy, variantId)) {
        if (await window.EhobbyAovDiscovery?.rejectIfUnavailable?.(card, variantId)) {
          await window.EhobbyAovDiscovery?.requestRediscovery?.(card.closest('.ehobby-aov'));
        }
        return false;
      }
      const allowed = await checkOptionalAdd(card, cart, pendingCards);
      if (!allowed) await window.EhobbyAovDiscovery?.requestRediscovery?.(card.closest('.ehobby-aov'), true);
      return allowed;
    };
    const createOptionalDiscoveryCheck = section => {
      let cartPromise;
      const checks = new Map();
      return async item => {
        if (!item) return false;
        if (!item.optional) return true;
        cartPromise ||= (async () => {
          const url = new URL(section.dataset.aovCartUrl || `${window.Shopify?.routes?.root || '/'}cart`, location.origin);
          if (url.origin !== location.origin) throw new Error('Unexpected cart origin');
          url.pathname = url.pathname.replace(/\/$/, '') + '.js';
          url.search = '';
          url.hash = '';
          return fetchJson(url, { fresh: true });
        })();
        const cart = await cartPromise;
        if (cart?.items?.some(line => line.handle === item.full?.handle)) return false;
        const policy = { optional: true, optionalConflictTags: Array.isArray(item.optionalConflictTags) ? [...new Set(item.optionalConflictTags)].sort() : [],
          optionalSource: item.optionalSource || null };
        const key = JSON.stringify(policy);
        if (!checks.has(key)) checks.set(key, checkOptionalAdd({
          dataset: { aovOptional: 'true' }, _aovOptionalPolicy: policy, closest: () => section
        }, cart));
        return checks.get(key);
      };
    };
    const discoveryInputs = async section => {
      const sources = [...new Map([...section.querySelectorAll('[data-aov-source-profile]')].map(sourceFrom).map(source => [source.handle, source])).values()];
      const inputs = [];
      const seenInputs = new Set();
      const addInput = (source, mode, query) => {
        const normalized = words(query);
        const key = `${source.handle}:${mode}:${normalized}`;
        if (!normalized || seenInputs.has(key)) return;
        seenInputs.add(key);
        inputs.push({ source, mode, query: normalized });
      };
      for (const source of sources) {
        for (const { group, reverse } of groupMemberships(source)) {
          addInput(source, 'exact', reverse ? group.sourceQuery : group.candidateQuery);
        }
        const vendor = valuesFor(source.tokens, 'vendor:')[0]?.replaceAll('-', ' ') || '';
        const platform = valuesFor(source.tokens, 'platform-')[0]?.replaceAll('-', ' ') || '';
        if ((source.role === 'gun' || source.role === 'magazine') && isSpecificFamily(source.type)) {
          const productKind = source.role === 'gun' ? `${platform} magazine` : `${platform} airsoft`;
          addInput(source, 'exact', `${vendor} ${source.type} ${productKind}`);
          addInput(source, 'exact', `${source.type} ${productKind}`);
          addInput(source, 'exact', `${vendor} ${source.type} ${source.role === 'gun' ? 'airsoft magazine' : 'airsoft gun'}`);
        }
        if (source.role === 'gun' && valuesFor(source.tokens, 'ammo-size-').includes('6mm')) {
          addInput(source, 'ammo', '6mm BB pellets');
          addInput(source, 'ammo', 'airsoft 6mm BB');
        }
        if (source.role === 'bb' && valuesFor(source.tokens, 'ammo-size-').includes('6mm')) addInput(source, 'related', '6mm airsoft gun');
        if (source.role === 'optic') {
          addInput(source, 'related', 'red dot sight');
          addInput(source, 'related', 'airsoft gun');
        }
        if (['magazine', 'external', 'internal'].includes(source.role) && source.type) {
          addInput(source, 'related', `${source.type} ${platform} airsoft gun`);
          addInput(source, 'related', `${source.type} airsoft gun`);
        }
        if (section.dataset.aovPlacement === 'product' && section.dataset.aovSurface !== 'drawer') {
          const accessory = valuesFor(source.tokens, 'accessory-type-')[0]?.replaceAll('-', ' ');
          const partType = tagValuesFor(source, 'Part-Type_')[0]?.replaceAll('-', ' ');
          const category = partType || accessory || (source.role === 'optic' ? 'red dot sight' : source.type);
          if (category && ['gun', 'magazine', 'bb', 'external', 'internal', 'optic', 'other'].includes(source.role)) {
            addInput(source, 'related', `${category} ${source.role === 'gun' ? 'airsoft' : source.role === 'magazine' ? 'magazine' : ''}`);
            const searchableCategory = words(category).replace(/\b(?:series|platforms?)\b/g, ' ').replace(/\s+/g, ' ').trim();
            if (searchableCategory && searchableCategory !== words(category)) addInput(source, 'related', `${searchableCategory} ${source.role === 'gun' ? 'airsoft rifle' : source.role === 'magazine' ? 'magazine' : ''}`);
            const kind = source.role === 'gun' ? 'airsoft rifle' : source.role === 'magazine' ? 'airsoft magazine' : source.role === 'optic' ? 'red dot sight' : partType || accessory;
            if (vendor && kind) addInput(source, 'related', `${vendor} ${kind}`);
          }
        }
      }
      const queries = [...new Set(roundRobinSources(inputs).map(input => input.query))].slice(0, 12);
      const groups = await mapLimit(queries, 4, async query => {
        try {
          const products = await search(section, query);
          return inputs.filter(input => input.query === query).flatMap(input => products.filter(product => preliminaryCompatibility(input.source, product, input.mode)).map(product => ({ ...input, product })));
        } catch (error) {
          recordDiscoveryFailure(section, error);
          return [];
        }
      });
      const nativeGroups = [];
      if (section.dataset.aovNative === 'true' && section.dataset.aovPlacement === 'product' && sources[0] && section.dataset.aovProductId && section.dataset.aovSectionId) {
        for (const mode of ['complementary', 'related']) {
          try {
            const url = new URL(section.dataset.aovRecommendationsUrl, location.origin);
            url.searchParams.set('section_id', section.dataset.aovSectionId);
            url.searchParams.set('product_id', section.dataset.aovProductId);
            url.searchParams.set('limit', '10');
            url.searchParams.set('intent', mode);
            const documentFragment = new DOMParser().parseFromString(await fetchText(url), 'text/html');
            documentFragment.querySelectorAll('[data-aov-native-candidate]').forEach(candidate => {
              nativeGroups.push({
                source: sources[0],
                mode,
                query: mode,
                product: { handle: candidate.dataset.aovHandle, url: candidate.dataset.aovUrl }
              });
            });
          } catch (error) { recordDiscoveryFailure(section, error); }
        }
      }
      const curatedHints = [...section.querySelectorAll('[data-aov-curated-hint]')].flatMap(hint => {
        const source = sources.find(source => source.handle === hint.dataset.aovCandidateOrigin);
        if (!source || !hint.dataset.aovCandidateHandle) return [];
        return [{ source, mode: 'complementary', query: 'curated-hint', product: { handle: hint.dataset.aovCandidateHandle, url: hint.dataset.aovCandidateUrl } }];
      });
      return [...groups.flat(), ...nativeGroups, ...curatedHints];
    };
    const discover = async (section, fresh = false) => {
      if (section.dataset.aovDynamic !== 'true' || section.dataset.aovDiscoveryState) return;
      section.dataset.aovDiscoveryState = 'loading';
      const cartRevision = section._aovCartRevision || 0;
      section._aovDiscoveryFailures = 0;
      section._aovRecoveryDelay = 1500;
      if (section._aovRecoveryRevision !== cartRevision) {
        section._aovRecoveryRevision = cartRevision;
        section._aovRecoveryAttempts = 0;
      }
      const status = section.querySelector('[data-aov-discovery-status]');
      try {
        const existingHandles = new Set([
          ...(window.EhobbyAovRemovalPreferences?.handles() || []),
          ...String(section.dataset.aovCartHandles || '').split('|').filter(Boolean),
          ...[...section.querySelectorAll('[data-aov-handle]')].map(node => node.dataset.aovHandle)
        ]);
        const inputs = await discoveryInputs(section);
        const candidateGroups = candidateGroupsFor(inputs, existingHandles);
        const optionalDiscoveryCheck = createOptionalDiscoveryCheck(section);
        const compatible = await mapLimit(candidateGroups, 4, async group => {
          try {
            const item = bestCompatibleMatch(group, await loadProduct(group.product, fresh));
            return await optionalDiscoveryCheck(item) ? item : null;
          }
          catch (error) {
            recordDiscoveryFailure(section, error);
            return null;
          }
        });
        if (cartRevision !== (section._aovCartRevision || 0)) {
          section.dataset.aovDiscoveryState = 'stale';
          section._aovRefreshRequested = true;
          return;
        }
        compatible.sort((left, right) => {
          const leftConfidence = confidenceFor(left.mode);
          const rightConfidence = confidenceFor(right.mode);
          const confidenceDifference = rightConfidence - leftConfidence;
          if (confidenceDifference) return confidenceDifference;
          const leftRatio = left.source.price ? Number(left.full.price) / left.source.price : 1;
          const rightRatio = right.source.price ? Number(right.full.price) / right.source.price : 1;
          return Math.abs(leftRatio - 0.12) - Math.abs(rightRatio - 0.12);
        });
        const selectedNeeds = new Map();
        const selectedCompatible = compatible.filter(item => {
          const need = needFor(item);
          const count = selectedNeeds.get(need) || 0;
          if (count >= 5) return false;
          selectedNeeds.set(need, count + 1);
          item.need = need;
          return true;
        });
        const grid = section.querySelector('.ehobby-aov__grid');
        let position = grid.querySelectorAll('.ehobby-aov__card').length;
        for (const item of selectedCompatible) {
          if (grid.querySelectorAll('.ehobby-aov__card').length >= 24) break;
          const reason = item.optional ? section.dataset.aovReasonOptional : item.mode === 'exact'
            ? section.dataset.aovReasonExact
            : item.mode === 'complementary'
              ? section.dataset.aovReasonComplementary
              : item.mode === 'related'
                ? section.dataset.aovReasonRelated
                : section.dataset.aovReasonAmmo;
          const confidence = confidenceFor(item.mode);
          const card = renderCard(section, item.full, item.source, reason, confidence, position++, item.need, item.mode, item.optional === true);
          if (card) {
            if (item.optional === true) card._aovOptionalPolicy = { optional: true, optionalConflictTags: [...(item.optionalConflictTags || [])], optionalSource: item.optionalSource, optionalPair: item.optionalPair };
            grid.append(card);
          }
        }
        if (grid.querySelector('.ehobby-aov__card')) section.hidden = false;
        section.dataset.aovDiscoveryState = section._aovDiscoveryFailures ? 'partial' : 'complete';
        window.EhobbyAovPersonalizer?.run();
        section.querySelector('ehobby-aov-bundle')?.sync?.();
        window.EhobbyAovMetrics?.observe?.();
      } catch {
        section.dataset.aovDiscoveryState = 'failed';
        if (status) status.textContent = '';
      } finally {
        if (section._aovRefreshRequested) {
          section._aovRefreshRequested = false;
          requestRediscovery(section);
        } else if (section.dataset.aovDiscoveryState === 'partial' && section._aovRecoveryAttempts < 1 && section._aovRecoveryDelay <= 30000) {
          section._aovRecoveryAttempts++;
          setTimeout(() => {
            if (section.isConnected && cartRevision === (section._aovCartRevision || 0) && section.dataset.aovDiscoveryState === 'partial') requestRediscovery(section);
          }, section._aovRecoveryDelay);
        }
      }
    };
    const requestRediscovery = (section, refreshOptional = false) => {
      if (!section?.isConnected || section.dataset.aovDynamic !== 'true') return;
      if (refreshOptional) {
        section.querySelectorAll('.ehobby-aov__card[data-aov-optional="true"]').forEach(card => card.remove());
        section._aovCartRevision = (section._aovCartRevision || 0) + 1;
      }
      if (section.dataset.aovDiscoveryState === 'loading') {
        section._aovRefreshRequested = true;
        return;
      }
      delete section.dataset.aovDiscoveryState;
      return discover(section, true);
    };
    const schedule = section => {
      if (typeof requestIdleCallback === 'function') requestIdleCallback(() => discover(section), { timeout: 1800 });
      else setTimeout(() => discover(section), 700);
    };
    const rejectCard = card => {
      const section = card?.closest('.ehobby-aov');
      if (!card || !section || card.dataset.aovRejected === 'true') return false;
      card.dataset.aovRejected = 'true';
      card.hidden = true;
      card.querySelectorAll('input, select, button').forEach(control => {
        if (control.matches('[data-aov-select]')) control.checked = false;
        control.disabled = true;
      });
      const status = section.querySelector('[data-aov-discovery-status]');
      if (status) status.textContent = section.dataset.aovReplaced || '';
      window.EhobbyAovPersonalizer?.refresh?.(section);
      section.querySelector('ehobby-aov-bundle')?.sync?.();
      window.EhobbyAovMetrics?.observe?.();
      return true;
    };
    const rejectIfUnavailable = async (card, variantId) => {
      const handle = card?.dataset.aovHandle;
      if (!card || !handle || !variantId) return false;
      try {
        const productLink = card.querySelector('a[href*="/products/"]');
        const product = await loadProduct({ handle, url: productLink?.href }, true);
        if (product?.handle !== handle || String(product.id) !== String(card.dataset.aovProduct) || !Array.isArray(product.variants)) return false;
        const variant = (product.variants || []).find(item => String(item.id) === String(variantId));
        if (variant?.available === true) return false;
        return rejectCard(card);
      } catch {
        return false;
      }
    };
    const observe = root => {
      const sections = [...root.querySelectorAll?.('.ehobby-aov[data-aov-dynamic="true"]') || []];
      sections.filter(section => section.hidden).forEach(schedule);
      const visibleSections = sections.filter(section => !section.hidden);
      if (typeof IntersectionObserver !== 'function') {
        visibleSections.forEach(discover);
        return;
      }
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          discover(entry.target);
        }
      }, { rootMargin: '500px 0px' });
      visibleSections.forEach(section => observer.observe(section));
    };
    const initialize = () => observe(document);
    window.EhobbyAovDiscovery = { discover, requestRediscovery, strictCompatibility, isSpecificFamily, roleFor, profileFor, rejectIfUnavailable, allowOptionalAdd, checkOptionalAdd, checkOptionalSubmission };
    document.addEventListener('shopify:section:load', event => observe(event.target));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  }

  if (!customElements.get('ehobby-aov-bundle')) {
    customElements.define('ehobby-aov-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.section = this.closest('.ehobby-aov');
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.count = this.querySelector('[data-aov-bundle-count]');
        this.total = this.querySelector('[data-aov-bundle-total]');
        this.savings = this.querySelector('[data-aov-bundle-savings]');
        this.buttonTotal = this.querySelector('[data-aov-bundle-button-total]');
        if (!this.section || !this.button || !this.status || !this.count || !this.total || !this.savings || !this.buttonTotal) return;
        this.initialized = true;
        this.changeHandler = event => this.change(event);
        this.addedHandler = event => this.added(event);
        this.clickHandler = () => this.submit();
        this.section.addEventListener('change', this.changeHandler);
        this.section.addEventListener('ehobby-aov:added', this.addedHandler);
        this.button.addEventListener('click', this.clickHandler);
        this.sync();
      }

      disconnectedCallback() {
        this.section?.removeEventListener('change', this.changeHandler);
        this.section?.removeEventListener('ehobby-aov:added', this.addedHandler);
        this.button?.removeEventListener('click', this.clickHandler);
        this.initialized = false;
      }

      formatMoney(cents) {
        const currency = window.Shopify?.currency?.active || 'USD';
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents) / 100); }
        catch { return `${(Number(cents) / 100).toFixed(2)} ${currency}`; }
      }

      change(event) {
        if (event.target.matches('.ehobby-aov__variant')) {
          const card = event.target.closest('.ehobby-aov__card');
          const checkbox = card?.querySelector('[data-aov-select]');
          const option = event.target.selectedOptions[0];
          if (checkbox && option?.value) {
            checkbox.dataset.aovVariant = option.value;
            checkbox.dataset.aovQuantity = option.dataset.min || '1';
            checkbox.dataset.aovUnitPrice = option.dataset.price || '0';
            checkbox.dataset.aovUnitSavings = option.dataset.savings || '0';
            checkbox.disabled = false;
            checkbox.checked = true;
            const quantityInput = card.querySelector('input[name="quantity"]');
            if (quantityInput) quantityInput.value = checkbox.dataset.aovQuantity;
            const price = Number(option.dataset.price);
            const savings = Number(option.dataset.savings || 0);
            if (Number.isSafeInteger(price) && price >= 0 && Number.isSafeInteger(savings) && savings >= 0) {
              card.dataset.aovPrice = String(price);
              card.dataset.aovSavings = String(savings);
              card.dataset.aovCompareAt = String(savings > 0 ? price + savings : 0);
              card.dataset.aovSale = String(savings > 0 ? Math.round(savings / (price + savings) * 100) : 0);
              const current = card.querySelector('.ehobby-aov__current-price');
              if (current) {
                current.textContent = this.formatMoney(price);
                let compare = current.parentElement.querySelector('.ehobby-aov__compare-price');
                if (savings > 0) {
                  if (!compare) {
                    compare = document.createElement('s');
                    compare.className = 'ehobby-aov__compare-price';
                    current.before(compare, document.createTextNode(' '));
                  }
                  compare.textContent = this.formatMoney(price + savings);
                } else compare?.remove();
              }
            }
          }
        }
        this.sync();
      }

      added(event) {
        const card = event.target.closest('.ehobby-aov__card');
        const checkbox = card?.querySelector('[data-aov-select]');
        if (checkbox) {
          checkbox.checked = false;
          checkbox.disabled = true;
        }
        window.EhobbyAovPersonalizer?.fulfill?.(this.section, [card?.dataset.aovNeed]);
        this.sync();
      }

      selected() {
        const seen = new Set();
        return [...this.section.querySelectorAll('[data-aov-select]:checked:not(:disabled)')].filter(input => {
          if (input.closest('.ehobby-aov__card')?.hidden || !input.dataset.aovVariant || seen.has(input.dataset.aovVariant) || window.EhobbyAovUncertainVariants?.has(input.dataset.aovVariant)) return false;
          seen.add(input.dataset.aovVariant);
          return true;
        });
      }

      sync() {
        const visibleSelectable = [...this.section.querySelectorAll('[data-aov-select]:not(:disabled)')].filter(input => !input.closest('.ehobby-aov__card')?.hidden);
        const selected = this.selected();
        const total = selected.reduce((sum, input) => sum + Number(input.dataset.aovUnitPrice || 0) * Number(input.dataset.aovQuantity || 1), 0);
        const savings = selected.reduce((sum, input) => sum + Number(input.dataset.aovUnitSavings || 0) * Number(input.dataset.aovQuantity || 1), 0);
        this.hidden = this.section.dataset.aovBundle !== 'true' || (!this.uncertain && visibleSelectable.length < 2);
        this.count.textContent = String(selected.length);
        this.total.textContent = selected.length ? this.formatMoney(total) : '';
        this.savings.textContent = savings > 0 ? String(this.section.dataset.aovSavingsTemplate || '').replace('__AMOUNT__', this.formatMoney(savings)) : '';
        this.savings.hidden = savings <= 0;
        this.buttonTotal.textContent = selected.length ? ` · ${this.formatMoney(total)}` : '';
        this.button.disabled = this.pending || this.uncertain || selected.length === 0;
      }

      async readCartBeforeBatch() {
        const url = new URL(this.section.dataset.aovCartUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('Unexpected cart origin');
        url.search = '';
        url.hash = '';
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
          const cart = await response.json();
          if (!response.ok || !Array.isArray(cart?.items) || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0
            || !cart.items.every(item => /^\d+$/.test(String(item.variant_id || item.id)) && Number.isSafeInteger(item.quantity) && item.quantity > 0)
            || cart.items.reduce((sum, item) => sum + item.quantity, 0) !== cart.item_count) throw new Error('Cart read not confirmed');
          return cart;
        } finally { clearTimeout(timer); }
      }

      async optionalBatchAllowed(cart, selected) {
        const cards = selected.map(input => input.closest('.ehobby-aov__card'));
        const submissions = selected.map((input, index) => ({ card: cards[index], variantId: input.dataset.aovVariant }));
        for (const { card, variantId } of submissions) {
          if (card?.dataset.aovOptional === 'true' && await window.EhobbyAovDiscovery?.checkOptionalSubmission?.(card, cart, cards, variantId) !== true) return false;
        }
        return true;
      }

      async requestBatch(url, items) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            signal: controller.signal,
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          const body = await response.json();
          return { response, body };
        } finally {
          clearTimeout(timer);
        }
      }

      async submit() {
        let selected = this.selected();
        if (this.pending || this.uncertain || !selected.length) return;
        this.pending = true;
        this.button.disabled = true;
        this.status.textContent = this.section.dataset.aovBundleLoading;
        const previous = window.EhobbyAovCartQueue || Promise.resolve();
        let release;
        window.EhobbyAovCartQueue = new Promise(resolve => { release = resolve; });
        try {
          await previous;
          const eligible = new Set(this.selected());
          selected = selected.filter(input => eligible.has(input));
          if (!selected.length) {
            this.status.textContent = '';
            return;
          }
          let before;
          try { before = await this.readCartBeforeBatch(); }
          catch {
            this.status.textContent = this.section.dataset.aovUncertain;
            const recovery = this.querySelector?.('[data-aov-bundle-recovery]');
            if (recovery) {
              recovery.href = window.EhobbyAovPreviewUrl?.(this.section.dataset.aovCartUrl) || this.section.dataset.aovCartUrl;
              recovery.hidden = false;
            }
            return;
          }
          const existing = new Set(before.items.map(item => String(item.variant_id || item.id)));
          const stillEligible = new Set(this.selected());
          selected = selected.filter(input => {
            if (existing.has(input.dataset.aovVariant)) {
              input.checked = false;
              input.disabled = true;
              return false;
            }
            return stillEligible.has(input);
          });
          if (!selected.length) { this.status.textContent = ''; return; }
          const selectionSnapshot = selected.map(input => ({ input, variant: input.dataset.aovVariant,
            quantity: input.dataset.aovQuantity || '1', price: input.dataset.aovUnitPrice, savings: input.dataset.aovUnitSavings }));
          if (!await this.optionalBatchAllowed(before, selected)) {
            this.status.textContent = this.section.dataset.aovUncertain;
            return;
          }
          const currentSelection = this.selected();
          if (currentSelection.length !== selectionSnapshot.length || selectionSnapshot.some(snapshot =>
            !currentSelection.includes(snapshot.input) || snapshot.input.dataset.aovVariant !== snapshot.variant
            || (snapshot.input.dataset.aovQuantity || '1') !== snapshot.quantity
            || snapshot.input.dataset.aovUnitPrice !== snapshot.price || snapshot.input.dataset.aovUnitSavings !== snapshot.savings)) {
            this.status.textContent = this.section.dataset.aovUncertain;
            return;
          }
          const url = new URL(this.section.dataset.aovCartAddUrl, location.origin);
          if (url.origin !== location.origin) throw new Error('Unexpected cart origin');
          url.pathname = url.pathname.replace(/\/$/, '') + '.js';
          const items = selected.map(input => ({ id: input.dataset.aovVariant, quantity: Number(input.dataset.aovQuantity || 1) }));
          if (!items.every(item => /^\d+$/.test(item.id) && Number.isSafeInteger(item.quantity) && item.quantity > 0)) {
            this.status.textContent = this.section.dataset.aovUncertain;
            return;
          }
          this.uncertain = true;
          const { response, body } = await this.requestBatch(url, items);
          const confirmed = Array.isArray(body?.items) && body.items.length === items.length && items.every(item => {
            const matches = body.items.filter(added => String(added?.variant_id || added?.id) === item.id);
            return matches.length === 1 && Number.isSafeInteger(matches[0].quantity) && matches[0].quantity === item.quantity;
          });
          if (!response.ok || !confirmed) {
            if (response.status === 422) {
              const rejected = await Promise.all(selected.map(input => window.EhobbyAovDiscovery?.rejectIfUnavailable?.(
                input.closest('.ehobby-aov__card'),
                input.dataset.aovVariant
              )));
              if (rejected.some(Boolean)) {
                this.status.textContent = this.section.dataset.aovUncertain;
                return;
              }
            }
            throw new Error(typeof body?.description === 'string' ? body.description : 'Bundle add failed');
          }
          this.uncertain = false;
          this.status.textContent = this.section.dataset.aovBundleSuccess;
          selected.forEach((input, index) => {
            input.checked = false;
            input.disabled = true;
            const card = input.closest('.ehobby-aov__card');
            const component = card?.querySelector('ehobby-aov-form');
            if (component) {
              component.finished = true;
              component.dataset.feedback = 'success';
              if (component.cartLink) component.cartLink.hidden = false;
            }
            const form = card?.querySelector('form');
            const button = form?.querySelector('button[type="submit"]');
            if (button) button.disabled = true;
            card?.querySelectorAll('select').forEach(select => { select.disabled = true; });
            const cardStatus = card?.querySelector('.ehobby-aov__status');
            if (cardStatus) cardStatus.textContent = this.section.dataset.aovSuccess;
            window.EhobbyAovMetrics?.track('ehobby_aov_add', card, { variant_id: items[index].id, quantity: items[index].quantity, method: 'bundle' });
          });
          window.EhobbyAovPersonalizer?.fulfill?.(this.section, selected.map(input => input.closest('.ehobby-aov__card')?.dataset.aovNeed));
          if (this.section.dataset.aovPlacement === 'cart') {
            location.assign(window.EhobbyAovPreviewUrl?.(this.section.dataset.aovCartUrl) || this.section.dataset.aovCartUrl);
            return;
          }
          const cartUrl = new URL(this.section.dataset.aovCartUrl, location.origin);
          cartUrl.pathname = cartUrl.pathname.replace(/\/$/, '') + '.js';
          const cartResponse = await fetch(cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
          const cart = await cartResponse.json();
          if (cartResponse.ok && Number.isInteger(cart.item_count)) {
            document.querySelectorAll('[data-header-cart-count]').forEach(counter => {
              counter.setAttribute('data-header-cart-count', String(cart.item_count));
              counter.textContent = String(cart.item_count);
              counter.classList.toggle('visible', cart.item_count > 0);
            });
          }
        } catch (error) {
          this.status.textContent = this.uncertain ? this.section.dataset.aovUncertain : (error.message || this.section.dataset.aovUncertain);
        } finally {
          if (this.uncertain) {
            window.EhobbyAovUncertainVariants ||= new Set();
            selected.forEach(input => {
              window.EhobbyAovUncertainVariants.add(input.dataset.aovVariant);
              input.disabled = true;
            });
            const link = this.querySelector?.('[data-aov-bundle-recovery]');
            if (link) {
              link.href = window.EhobbyAovPreviewUrl?.(this.section.dataset.aovCartUrl) || this.section.dataset.aovCartUrl;
              link.hidden = false;
            }
          }
          release();
          this.pending = false;
          this.sync();
        }
      }
    });
  }

  if (!window.EhobbyAovNativeCart) {
    let operations = 0;
    let uncertain = false;
    const settledRemovals = new WeakSet();
    const saved = new Map();
    let feedback;
    const controls = () => [...document.querySelectorAll('[name="checkout"], .additional-checkout-buttons')];
    const lock = () => {
      controls().forEach(node => {
        if (!saved.has(node)) saved.set(node, { disabled: node.disabled, inert: node.inert, busy: node.getAttribute('aria-busy') });
        if ('disabled' in node) node.disabled = true;
        node.inert = true;
        node.setAttribute('aria-busy', 'true');
      });
    };
    const unlock = () => {
      if (operations || uncertain) return;
      for (const [node, state] of saved) {
        if ('disabled' in node) node.disabled = state.disabled;
        node.inert = state.inert;
        if (state.busy === null) node.removeAttribute('aria-busy');
        else node.setAttribute('aria-busy', state.busy);
      }
      saved.clear();
      feedback?.remove();
      feedback = null;
    };
    const status = failed => {
      const section = document.querySelector('.ehobby-aov[data-aov-placement="cart"]');
      const root = document.querySelector('.cart-checkout');
      if (!section || !root) return;
      feedback?.remove();
      feedback = document.createElement('div');
      feedback.setAttribute('role', failed ? 'alert' : 'status');
      feedback.dataset.aovNativeCartStatus = failed ? 'failed' : 'pending';
      feedback.textContent = failed ? section.dataset.aovCartRetry : section.dataset.aovCartUpdating;
      if (failed) {
        const link = document.createElement('a');
        link.href = window.EhobbyAovPreviewUrl?.(section.dataset.aovCartUrl) || section.dataset.aovCartUrl;
        link.textContent = section.dataset.aovViewCart;
        feedback.append(document.createTextNode(' '), link);
      }
      root.prepend(feedback);
    };
    const validCart = cart => {
      const keys = new Set();
      return Array.isArray(cart?.items) && Number.isSafeInteger(cart.item_count) && cart.item_count >= 0
        && Number.isSafeInteger(cart.total_price) && cart.total_price >= 0 && typeof cart.currency === 'string' && /^[A-Z]{3}$/.test(cart.currency)
        && cart.items.every(item => {
          if (!item || typeof item.key !== 'string' || !item.key.trim() || keys.has(item.key)
            || !Number.isSafeInteger(item.variant_id) || item.variant_id < 1 || item.id !== item.variant_id
            || !Number.isSafeInteger(item.quantity) || item.quantity < 1) return false;
          keys.add(item.key);
          return true;
        }) && cart.items.reduce((sum, item) => sum + item.quantity, 0) === cart.item_count;
    };
    const request = async (url, options) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
        const cart = await response.json();
        if (!response.ok || !validCart(cart)) throw new Error('Native cart update not confirmed');
        return cart;
      } finally { clearTimeout(timer); }
    };
    const change = async (owner, row, quantity) => {
      if (!Number.isInteger(quantity) || quantity < 0 || uncertain) return;
      const id = row.data('cartitem-id');
      if (!id) return;
      const actionKey = row.attr?.('data-cartitem-key') || row.data('cartitem-key');
      const actionMatches = (owner.cart?.items || []).filter(item => String(item.id) === String(id));
      const actionTarget = typeof actionKey === 'string' ? actionMatches.find(item => item.key === actionKey) : actionMatches.length === 1 ? actionMatches[0] : null;
      const expectedQuantity = actionTarget?.quantity;
      const expectedKey = actionTarget?.key;
      const previous = window.EhobbyAovCartQueue || Promise.resolve();
      let release;
      window.EhobbyAovCartQueue = new Promise(resolve => { release = resolve; });
      operations++;
      lock();
      status(false);
      try {
        await previous.catch(() => {});
        if (uncertain) return;
        if (settledRemovals.has(row[0] || row)) return;
        const root = window.Shopify?.routes?.root || '/';
        const priorItems = owner.cart?.items || [];
        const rowKey = row.attr?.('data-cartitem-key') || row.data('cartitem-key');
        const matches = priorItems.filter(item => String(item.id) === String(id));
        const target = typeof rowKey === 'string' ? matches.find(item => item.key === rowKey) : matches.length === 1 ? matches[0] : null;
        if (!target) throw new Error('Cart line identity is ambiguous');
        const targetId = target.key || String(id);
        const fresh = await request(new URL(root + 'cart.js', location.origin), { headers: { Accept: 'application/json' } });
        const freshMatches = fresh.items.filter(item => target.key ? item.key === target.key && String(item.id) === String(id) : String(item.id) === String(id));
        if (!actionTarget || target.key !== expectedKey || freshMatches.length !== 1 || freshMatches[0].quantity !== expectedQuantity || target.quantity !== expectedQuantity) {
          throw new Error('Cart changed before update; reload required');
        }
        const removal = quantity === 0 ? target : null;
        let cart;
        let recovered = false;
        try {
          cart = await request(new URL(root + 'cart/change.js', location.origin), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: targetId, quantity }) });
        } catch {
          recovered = true;
          cart = await request(new URL(root + 'cart.js', location.origin), { headers: { Accept: 'application/json' } });
        }
        if (target.key) {
          const expected = priorItems.filter(item => item.key !== target.key);
          if (expected.some(item => !cart.items.some(current => current.key === item.key)) || cart.items.some(item => !priorItems.some(old => old.key === item.key))) throw new Error('Cart line keys changed; reload required');
          if (quantity > 0 && !cart.items.some(item => item.key === target.key)) throw new Error('Changed target key; reload required');
        }
        window.EhobbyAovRemovalPreferences?.confirmRemoval(removal, quantity, cart);
        owner._didUpdate(id, quantity, cart, row);
        if (quantity === 0 && !cart.items.some(item => target.key ? item.key === target.key : String(item.id) === String(id))) settledRemovals.add(row[0] || row);
        if (recovered && cart.items.filter(item => target.key ? item.key === target.key : String(item.id) === String(id)).reduce((sum, item) => sum + item.quantity, 0) !== quantity) {
          uncertain = true;
          status(true);
        }
        if (!cart.item_count) uncertain = true;
      } catch {
        uncertain = true;
        status(true);
      } finally {
        operations--;
        if (operations || uncertain) lock();
        else unlock();
        release();
      }
    };
    const blockCheckout = event => {
      if (!operations && !uncertain) return;
      const target = event.target;
      if (target?.closest?.('[name="checkout"], .additional-checkout-buttons') || (event.type === 'submit' && target?.querySelector?.('[name="checkout"]'))) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    document.addEventListener('click', blockCheckout, true);
    document.addEventListener('submit', blockCheckout, true);
    window.EhobbyAovNativeCart = { change, isLocked: () => operations > 0 || uncertain };
  }

  if (!window.EhobbyAovCartPage) {
    let revision = 0;
    let pending;
    const refresh = async cart => {
      if (!Array.isArray(cart?.items) || !Number.isInteger(cart.item_count)) return;
      const current = ++revision;
      pending?.abort();
      const sections = [...document.querySelectorAll('.ehobby-aov[data-aov-placement="cart"]')];
      sections.forEach(section => {
        section.hidden = true;
        section._aovCartRevision = (section._aovCartRevision || 0) + 1;
      });
      if (!sections.length) return;
      const controller = new AbortController();
      pending = controller;
      const timer = setTimeout(() => controller.abort(), 12000);
      try {
        for (const section of sections) {
          const id = section.dataset.aovSectionId;
          if (!id || !section.isConnected) continue;
          const url = new URL(window.EhobbyAovPreviewUrl?.(location.href) || location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', id);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Cart recommendation refresh failed');
          const body = await response.json();
          if (typeof body[id] !== 'string') throw new Error('Cart recommendation section missing');
          if (current !== revision || !section.isConnected || controller.signal.aborted) return;
          const fragment = new DOMParser().parseFromString(body[id], 'text/html');
          const replacement = [...fragment.querySelectorAll('.ehobby-aov[data-aov-placement="cart"]')].find(node => node.dataset.aovSectionId === id);
          if (!replacement) {
            section.remove();
            continue;
          }
          section.replaceWith(replacement);
          window.EhobbyAovPersonalizer?.run();
          window.EhobbyAovDiscovery?.discover(replacement, true);
          window.EhobbyAovMetrics?.observe?.();
        }
      } catch {
        if (current === revision) sections.filter(section => section.isConnected).forEach(section => { section.dataset.aovCartRefresh = 'failed'; });
      } finally {
        clearTimeout(timer);
        if (current === revision) pending = null;
      }
    };
    window.EhobbyAovCartPage = { refresh };
    document.addEventListener('ehobby-aov:native-cart-updated', event => refresh(event.detail?.cart));
  }

  const syncBundles = () => document.querySelectorAll('ehobby-aov-bundle').forEach(bundle => bundle.sync?.());
  document.addEventListener('visitorConsentCollected', syncBundles);
  document.addEventListener('shopify:section:load', syncBundles);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ehobby-aov-recommendations"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.add('ehobby-aov-hub-active');

  if (!window.EhobbyAovPositioner) {
    let timer;
    const place = () => {
      document.querySelectorAll('.ehobby-aov[data-aov-placement="product"]').forEach(section => {
        const product = document.querySelector('[data-product-wrapper]');
        const form = product?.querySelector('[id^="product_form_"]');
        if (!form) return;
        section.classList.add('ehobby-aov--purchase-panel');
        if (form.nextElementSibling !== section) form.insertAdjacentElement('afterend', section);
      });
    };
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(place, 120);
    };
    window.EhobbyAovPositioner = { run: place };
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place, { once: true });
    else place();
    setTimeout(place, 500);
    setTimeout(place, 1500);
  } else {
    window.EhobbyAovPositioner.run();
  }

  if (!window.EhobbyAovRemovalPreferences) {
    const removed = new Map();
    const persisted = new Map();
    const storageKey = 'ehobby:aov:removed:v1';
    const maxAge = 30 * 60 * 1000;
    let loaded = false;
    let cleared = false;
    let permitted = false;
    const prune = () => {
      const now = Date.now();
      for (const map of [removed, persisted]) for (const [handle, expires] of map) if (expires <= now) map.delete(handle);
      const merged = new Map(persisted);
      for (const [handle, expires] of removed) merged.set(handle, Math.max(expires, merged.get(handle) || 0));
      const oldest = [...merged].sort((a, b) => a[1] - b[1]);
      while (oldest.length > 100) {
        const [handle] = oldest.shift();
        removed.delete(handle);
        persisted.delete(handle);
      }
    };
    const syncConsent = () => {
      const privacy = window.Shopify?.customerPrivacy;
      const known = typeof privacy?.preferencesProcessingAllowed === 'function' && typeof privacy?.analyticsProcessingAllowed === 'function';
      try { permitted = known && privacy.preferencesProcessingAllowed() === true && privacy.analyticsProcessingAllowed() === true; }
      catch { permitted = false; }
      if (!permitted) {
        persisted.clear();
        loaded = false;
        if (known && !cleared) {
          try { sessionStorage.removeItem(storageKey); } catch {}
          cleared = true;
        }
        return false;
      }
      cleared = false;
      if (!loaded) {
        loaded = true;
        try {
          const raw = sessionStorage.getItem(storageKey);
          const entries = raw && raw.length <= 60000 ? JSON.parse(raw) : [];
          const now = Date.now();
          if (Array.isArray(entries) && entries.length <= 100) {
            for (const entry of entries) {
              if (Array.isArray(entry) && entry.length === 2 && typeof entry[0] === 'string' && entry[0].length > 0 && entry[0].length <= 255 && Number.isFinite(entry[1]) && entry[1] > now && entry[1] <= now + maxAge) persisted.set(entry[0], entry[1]);
            }
          }
        } catch {}
      }
      prune();
      return true;
    };
    const has = handle => { syncConsent(); prune(); return removed.has(handle) || persisted.has(handle); };
    const handles = () => { syncConsent(); prune(); return [...new Set([...removed.keys(), ...persisted.keys()])]; };
    const confirmRemoval = (item, quantity, cart) => {
      if (quantity !== 0 || typeof item?.handle !== 'string' || !item.handle || item.handle.length > 255 || !Array.isArray(cart?.items) || !Number.isInteger(cart.item_count) || cart.item_count < 0) return false;
      if (cart.items.some(line => typeof line.handle !== 'string' || !Number.isInteger(line.quantity) || line.quantity < 1) || cart.items.reduce((sum, line) => sum + line.quantity, 0) !== cart.item_count || cart.items.some(line => line.handle === item.handle)) return false;
      const allowed = syncConsent();
      const expires = Date.now() + maxAge;
      removed.delete(item.handle);
      removed.set(item.handle, expires);
      if (allowed) persisted.set(item.handle, expires);
      prune();
      if (allowed) {
        try { sessionStorage.setItem(storageKey, JSON.stringify([...persisted])); } catch {}
      }
      return true;
    };
    const onConsent = () => {
      const previous = permitted;
      syncConsent();
      if (previous !== permitted) {
        window.EhobbyAovPersonalizer?.run();
        document.querySelectorAll('.ehobby-aov[data-aov-dynamic="true"]').forEach(section => window.EhobbyAovDiscovery?.requestRediscovery?.(section));
      }
    };
    document.addEventListener('visitorConsentCollected', onConsent);
    window.EhobbyAovRemovalPreferences = { has, handles, confirmRemoval };
  }

  if (!window.EhobbyAovPersonalizer) {
    const storageKey = 'ehobby:aov:preferences:v1';
    const maxHistory = 20;
    const maxAge = 30 * 24 * 60 * 60 * 1000;
    const privacyAllowed = () => {
      try {
        return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
      } catch { return false; }
    };
    const tokensFor = element => (element?.dataset.aovProfile || '').split('|').map(token => token.replaceAll('_', '-')).filter(Boolean);
    const readHistory = () => {
      if (!privacyAllowed()) return [];
      try {
        const now = Date.now();
        const history = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(history)) return [];
        return history.filter(item => item && typeof item.handle === 'string' && item.handle.trim() !== '' && Array.isArray(item.tokens) && item.tokens.length > 0 && item.tokens.every(token => typeof token === 'string' && token.trim() !== '') && Number.isFinite(item.at) && item.at >= 0 && item.at <= now && now - item.at < maxAge && Number.isFinite(item.price) && item.price >= 0).slice(0, maxHistory);
      } catch { return []; }
    };
    const writeHistory = history => {
      try { localStorage.setItem(storageKey, JSON.stringify(history.slice(0, maxHistory))); }
      catch {}
    };
    const rememberCurrentProduct = () => {
      const current = document.querySelector('[data-aov-current-profile]');
      if (!current || !privacyAllowed()) return;
      const handle = current.dataset.aovHandle;
      const tokens = tokensFor(current);
      if (!handle || !tokens.length) return;
      const price = Number(current.dataset.aovPrice);
      const history = readHistory().filter(item => item.handle !== handle);
      history.unshift({ handle, tokens, price: Number.isFinite(price) ? price : 0, at: Date.now() });
      writeHistory(history);
    };
    const tokenValue = token => {
      if (token.startsWith('platform-') || token.startsWith('originating-armory-')) return 4;
      if (token.startsWith('vendor:') || token.startsWith('type:')) return 2;
      return 1;
    };
    const scoreCard = (card, history) => {
      const tokens = new Set(tokensFor(card));
      let score = (Number(card.dataset.aovConfidence) || 0) * 0.5;
      score += Math.min(8, Math.max(0, Number(card.dataset.aovSale) || 0));
      const originPrice = Number(card.dataset.aovOriginPrice);
      const candidatePrice = Number(card.dataset.aovPrice);
      if (originPrice > 0 && candidatePrice > 0) {
        const role = card.dataset.aovRole;
        const targetRatio = role === 'gun' ? 8 : role === 'bb' ? 0.05 : 0.12;
        score += Math.max(0, 10 - Math.abs(Math.log((candidatePrice / originPrice) / targetRatio)) * 4);
      }
      history.forEach((item, index) => {
        const recency = Math.max(1, 12 - index);
        item.tokens.forEach(token => {
          if (tokens.has(token)) score += recency * tokenValue(token);
        });
        if (item.handle === card.dataset.aovOrigin) score += recency * 8;
      });
      const prices = history.map(item => item.price).filter(price => Number.isFinite(price) && price > 0).sort((a, b) => a - b);
      const cardPrice = Number(card.dataset.aovPrice);
      if (prices.length >= 3 && Number.isFinite(cardPrice) && cardPrice > 0) {
        const median = prices[Math.floor(prices.length / 2)];
        score += Math.max(0, 6 - Math.abs(Math.log(cardPrice / median)) * 2);
      }
      return score;
    };
    const needFor = card => {
      if (card.dataset.aovStrategy === 'related') {
        return `alternative:${card.dataset.aovHandle}`;
      }
      return card.dataset.aovNeed || card.dataset.aovRole || card.dataset.aovHandle;
    };
    const cartCoversNeed = (section, card) => {
      if (card.dataset.aovRole !== 'bb') return false;
      const sizes = tokensFor(card).filter(token => token.startsWith('ammo-size-'));
      if (!sizes.length) return false;
      if (section._aovConfirmedCartHandles && [...section.querySelectorAll('.ehobby-aov__card[data-aov-role="bb"]')].some(item => section._aovConfirmedCartHandles.has(item.dataset.aovHandle) && tokensFor(item).some(token => sizes.includes(token)))) return true;
      return [...section.querySelectorAll('[data-aov-cart-product]')].some(item => {
        if (section._aovConfirmedCartHandles && !section._aovConfirmedCartHandles.has(item.dataset.aovCartHandle)) return false;
        let tags;
        try { tags = JSON.parse(item.dataset.aovTags || '[]'); } catch { return false; }
        if (!Array.isArray(tags)) return false;
        const role = window.EhobbyAovDiscovery?.roleFor({ title: item.dataset.aovTitle, tags });
        return role === 'bb' && tokensFor(item).some(token => sizes.includes(token));
      });
    };
    const updateNarrative = (section, totalNeeds, fulfilledNeeds) => {
      const heading = section.querySelector('.ehobby-aov__heading');
      const profile = section.querySelector('[data-aov-source-profile]');
      const remaining = Math.max(0, totalNeeds - fulfilledNeeds);
      if (heading && remaining > 0) {
        const cartPlacement = section.dataset.aovPlacement === 'cart';
        const template = cartPlacement
          ? remaining === 1 ? section.dataset.aovHeadingCartOne : section.dataset.aovHeadingCartMany
          : remaining === 1 ? section.dataset.aovHeadingProductOne : section.dataset.aovHeadingProductMany;
        const product = profile?.dataset.aovType || profile?.dataset.aovTitle || '';
        heading.textContent = String(template || heading.textContent).replace('__PRODUCT__', product).replace('__COUNT__', String(remaining));
      }
      const progress = section.querySelector('[data-aov-progress]');
      const track = progress?.querySelector('[role="progressbar"]');
      const fill = progress?.querySelector('[data-aov-progress-fill]');
      const text = progress?.querySelector('[data-aov-progress-text]');
      if (!progress || !track || !fill || !text || totalNeeds < 1) return;
      progress.hidden = false;
      track.setAttribute('aria-valuemax', String(totalNeeds));
      track.setAttribute('aria-valuenow', String(fulfilledNeeds));
      fill.style.setProperty('--aov-progress', `${Math.round((fulfilledNeeds / totalNeeds) * 100)}%`);
      const progressTemplate = totalNeeds === 1 ? section.dataset.aovProgressOne : section.dataset.aovProgressMany;
      text.textContent = String(progressTemplate || '').replace('__SELECTED__', String(fulfilledNeeds)).replace('__TOTAL__', String(totalNeeds));
    };
    const orderSection = (section, history) => {
      const grid = section.querySelector('.ehobby-aov__grid');
      if (!grid) return;
      const limit = Math.max(1, Math.min(3, Number(section.dataset.aovLimit) || 3));
      const cards = [...grid.querySelectorAll('.ehobby-aov__card')];
      const fulfilled = section._aovFulfilledNeeds || new Set();
      section._aovFulfilledNeeds = fulfilled;
      cards.sort((a, b) => {
        const strategyDifference = Number(a.dataset.aovStrategy === 'related') - Number(b.dataset.aovStrategy === 'related');
        if (strategyDifference) return strategyDifference;
        const scoreDifference = scoreCard(b, history) - scoreCard(a, history);
        if (scoreDifference) return scoreDifference;
        return Number(a.dataset.aovPosition) - Number(b.dataset.aovPosition);
      });
      const eligibleCards = cards.filter(card => card.dataset.aovRejected !== 'true' && !window.EhobbyAovRemovalPreferences?.has(card.dataset.aovHandle) && !section._aovConfirmedCartHandles?.has(card.dataset.aovHandle) && !cartCoversNeed(section, card));
      const totalNeeds = new Set(eligibleCards.filter(card => card.dataset.aovStrategy !== 'related').map(needFor).filter(Boolean));
      const visibleNeeds = new Set();
      const more = section.querySelector('[data-aov-more]');
      const primary = new Set();
      const eligible = eligibleCards.filter(card => Boolean(needFor(card)) && !fulfilled.has(needFor(card)));
      eligible.forEach(card => {
        const need = needFor(card);
        if (!visibleNeeds.has(need) && primary.size < limit) {
          primary.add(card);
          visibleNeeds.add(need);
        }
      });
      const extras = eligible.filter(card => !primary.has(card)).slice(0, 12 - primary.size);
      if (more && !more._aovBound) {
        more._aovBound = true;
        more.addEventListener('click', () => {
          section._aovExpanded = !section._aovExpanded;
          orderSection(section, readHistory());
          window.EhobbyAovMetrics?.observe?.();
        });
      }
      if (more) {
        more.hidden = extras.length === 0;
        more.setAttribute('aria-expanded', String(Boolean(section._aovExpanded)));
        more.textContent = section._aovExpanded ? more.dataset.aovLessLabel : more.dataset.aovMoreLabel;
      }
      let visibleCount = 0;
      cards.forEach(card => {
        grid.append(card);
        const extra = Boolean(more && extras.includes(card));
        if (extra && !card._aovMoreInitialized) {
          const checkbox = card.querySelector('[data-aov-select]');
          if (checkbox) checkbox.checked = false;
          card._aovMoreInitialized = true;
        }
        const show = primary.has(card) || (extra && section._aovExpanded === true);
        card.hidden = !show;
        if (show) {
          visibleCount += 1;
        }
      });
      section.dataset.aovPersonalized = history.length ? 'true' : 'false';
      updateNarrative(section, totalNeeds.size, [...fulfilled].filter(need => totalNeeds.has(need)).length);
      if (totalNeeds.size === 0) {
        const progress = section.querySelector('[data-aov-progress]');
        if (progress) progress.hidden = true;
      }
      section.hidden = visibleCount === 0;
      section.querySelector('ehobby-aov-bundle')?.sync?.();
    };
    const fulfill = (section, needs) => {
      if (!section) return;
      const fulfilled = section._aovFulfilledNeeds || new Set();
      needs.filter(Boolean).forEach(need => fulfilled.add(need));
      section._aovFulfilledNeeds = fulfilled;
      orderSection(section, readHistory());
      window.EhobbyAovMetrics?.observe?.();
    };
    const refresh = section => {
      if (!section) return;
      orderSection(section, readHistory());
    };
    const reconcileCart = cart => {
      if (!Array.isArray(cart?.items) || !Number.isInteger(cart.item_count) || cart.item_count < 0 || cart.items.some(item => typeof item.handle !== 'string' || !item.handle || !Number.isInteger(item.quantity) || item.quantity < 1) || cart.items.reduce((sum, item) => sum + item.quantity, 0) !== cart.item_count) return;
      const handles = new Set(cart.items.map(item => item.handle));
      document.querySelectorAll('.ehobby-aov[data-aov-placement="product"]').forEach(section => {
        const previous = section._aovConfirmedCartHandles || new Set(String(section.dataset.aovCartHandles || '').split('|').filter(Boolean));
        const cards = [...section.querySelectorAll('.ehobby-aov__card')];
        const missingRemovedCandidate = [...previous].some(handle => !handles.has(handle) && !cards.some(card => card.dataset.aovHandle === handle));
        if (previous.size !== handles.size || [...previous].some(handle => !handles.has(handle))) section._aovCartRevision = (section._aovCartRevision || 0) + 1;
        section._aovConfirmedCartHandles = handles;
        section.dataset.aovCartHandles = [...handles].map(handle => `|${handle}|`).join('');
        const fulfilled = new Set();
        section.querySelectorAll('.ehobby-aov__card').forEach(card => {
          const present = handles.has(card.dataset.aovHandle);
          if (present) fulfilled.add(needFor(card));
          else if (card._aovWasInCart) card.querySelector('ehobby-aov-form')?.restoreAfterRemoval?.();
          card._aovWasInCart = present;
        });
        section._aovFulfilledNeeds = fulfilled;
        orderSection(section, readHistory());
        if (missingRemovedCandidate) window.EhobbyAovDiscovery?.requestRediscovery?.(section);
      });
      window.EhobbyAovMetrics?.observe?.();
    };
    const run = () => {
      if (!privacyAllowed()) {
        try { localStorage.removeItem(storageKey); }
        catch {}
      }
      rememberCurrentProduct();
      const history = readHistory();
      document.querySelectorAll('.ehobby-aov[data-aov-limit]').forEach(section => orderSection(section, history));
    };
    const initialize = () => {
      if (window.Shopify?.customerPrivacy) run();
      else {
        document.querySelectorAll('.ehobby-aov[data-aov-limit]').forEach(section => orderSection(section, []));
        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) run(); });
      }
    };
    window.EhobbyAovPersonalizer = { run, fulfill, refresh, reconcileCart };
    document.addEventListener('ehobby-aov:cart-rendered', event => reconcileCart(event.detail?.cart));
    document.addEventListener('visitorConsentCollected', run);
    document.addEventListener('shopify:section:load', run);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  }
  if (!customElements.get('ehobby-aov-form')) {
    customElements.define('ehobby-aov-form', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.status = this.querySelector('[role="status"]');
        this.cartLink = this.querySelector('.ehobby-aov__cart-link');
        if (!this.form || !this.button || !this.status || !this.cartLink) return;
        if (this.idleLabel === undefined) this.idleLabel = this.button.textContent;
        if (!this.initialControlStates) this.initialControlStates = [...this.form.querySelectorAll('select'), ...this.querySelectorAll('[data-aov-select]')].map(control => ({ control, disabled: control.disabled }));
        this.initialized = true;
        this.submitHandler = event => this.submit(event);
        this.form.addEventListener('submit', this.submitHandler);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.submitHandler);
        this.initialized = false;
      }

      restoreAfterRemoval() {
        if (this.pending || this.dataset.feedback === 'attention' || this.closest('.ehobby-aov__card')?.dataset.aovRejected === 'true') return;
        this.finished = false;
        this.button.disabled = false;
        this.button.textContent = this.idleLabel;
        this.status.textContent = '';
        this.cartLink.hidden = true;
        delete this.dataset.feedback;
        for (const { control, disabled } of this.initialControlStates || []) {
          control.disabled = disabled;
          if (control.matches('[data-aov-select]')) control.checked = false;
        }
      }

      async request(url, options = {}) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(url, { ...options, credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) console.warn('eHobby AOV response ' + (options.method || 'GET') + ' ' + response.status);
          let body;
          try { body = await response.json(); }
          catch (error) {
            error.status = response.status;
            console.warn('eHobby AOV non-JSON response ' + (options.method || 'GET') + ' ' + response.status);
            throw error;
          }
          return { response, body };
        } finally {
          clearTimeout(timer);
        }
      }

      async readCart(url) {
        for (let attempt = 0; attempt < 3; attempt++) {
          try {
            const cart = await this.request(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
            if (!cart.response.ok || !Number.isInteger(cart.body.item_count)) {
              const error = new Error('Cart refresh failed');
              error.status = cart.response.status;
              throw error;
            }
            return cart;
          } catch (error) {
            if (attempt === 2 || (error.status && error.status !== 429 && error.status < 500)) throw error;
            await new Promise(resolve => setTimeout(resolve, 300 * (attempt + 1)));
          }
        }
      }

      async preflightSingleAdd(variantId) {
        const url = new URL(this.dataset.cartUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('Unexpected cart origin');
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
        url.search = '';
        url.hash = '';
        const { response, body } = await this.request(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok || !Array.isArray(body?.items) || !Number.isSafeInteger(body.item_count) || body.item_count < 0 ||
            body.items.some(item => !/^[1-9]\d*$/.test(String(item?.variant_id ?? item?.id)) || !Number.isSafeInteger(item.quantity) || item.quantity < 1) ||
            body.items.reduce((sum, item) => sum + item.quantity, 0) !== body.item_count) throw new Error('Cart preflight failed');
        const card = this.closest('.ehobby-aov__card');
        if (card?.dataset.aovOptional === 'true' && await window.EhobbyAovDiscovery?.checkOptionalSubmission?.(card, body, [], variantId) !== true) throw new Error('Optional pairing needs an updated cart review');
        return !body.items.some(item => String(item.variant_id ?? item.id) === variantId);
      }

      async submit(event) {
        event.preventDefault();
        if (this.pending || this.finished || !this.form.reportValidity()) return;
        const payload = new FormData(this.form);
        this.pending = true;
        this.button.disabled = true;
        this.form.querySelectorAll('select').forEach(select => { select.disabled = true; });
        this.form.setAttribute('aria-busy', 'true');
        this.dataset.feedback = 'loading';
        this.status.textContent = this.dataset.loading;
        let added = false;
        let completed = false;
        let postStarted = false;
        const variantId = String(payload.get('id'));
        const quantity = Number(payload.get('quantity'));
        const previous = window.EhobbyAovCartQueue || Promise.resolve();
        let release;
        window.EhobbyAovCartQueue = new Promise(resolve => { release = resolve; });
        try {
          await previous;
          if (this.finished) {
            completed = true;
            this.dataset.feedback = 'success';
            this.status.textContent = this.dataset.success;
            return;
          }
          if (window.EhobbyAovUncertainVariants?.has(String(payload.get('id')))) {
            this.finished = true;
            this.dataset.feedback = 'attention';
            this.cartLink.hidden = false;
            this.status.textContent = this.dataset.uncertain;
            return;
          }
          const url = new URL(this.form.action, location.origin);
          if (url.origin !== location.origin) throw new Error('Unexpected cart origin');
          if (!/^[1-9]\d*$/.test(variantId) || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Invalid add quantity or variant');
          if (!await this.preflightSingleAdd(variantId)) {
            this.finished = true;
            this.dataset.feedback = 'attention';
            this.cartLink.hidden = false;
            this.status.textContent = this.dataset.uncertain;
            return;
          }
          url.pathname = url.pathname.replace(/\/$/, '') + '.js';
          window.EhobbyAovUncertainVariants ||= new Set();
          window.EhobbyAovUncertainVariants.add(variantId);
          postStarted = true;
          const { response, body } = await this.request(url, { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
          if (!response.ok || String(body?.id) !== variantId || body?.quantity !== quantity) {
            this.finished = true;
            const card = this.closest('.ehobby-aov__card');
            const replaced = response.status === 422
              ? await window.EhobbyAovDiscovery?.rejectIfUnavailable?.(card, payload.get('id'))
              : false;
            if (replaced) return;
            this.dataset.feedback = 'attention';
            this.cartLink.hidden = false;
            this.status.textContent = [typeof body?.description === 'string' ? body.description : '', this.dataset.uncertain].filter(Boolean).join(' ');
            return;
          }
          window.EhobbyAovUncertainVariants.delete(variantId);
          added = true;
          completed = true;
          this.finished = true;
          this.dataset.feedback = 'success';
          this.status.textContent = this.dataset.success;
          window.EhobbyAovMetrics?.track('ehobby_aov_add', this.closest('.ehobby-aov__card'), { variant_id: String(body.id), quantity: Number(payload.get('quantity')) });
          if (this.dataset.page !== 'cart' && window.EhobbyAovDrawerBridge?.open(this.button)) {
            this.dispatchEvent(new CustomEvent('ehobby-aov:added', { bubbles: true, detail: { variantId: body.id, quantity: Number(payload.get('quantity')), drawerHandled: true } }));
            return;
          }
          try {
            window.api?.theme?.triggerEvent('cart:updated', { cancel: () => {} });
          } catch {}
          if (this.dataset.page === 'cart') {
            location.assign(window.EhobbyAovPreviewUrl?.(this.dataset.cartUrl) || this.dataset.cartUrl);
            return;
          }
          const cartUrl = new URL(this.dataset.cartUrl, location.origin);
          cartUrl.pathname = cartUrl.pathname.replace(/\/$/, '') + '.js';
          const cart = await this.readCart(cartUrl);
          window.EhobbyAovPersonalizer?.reconcileCart?.(cart.body);
          document.querySelectorAll('[data-header-cart-count]').forEach(counter => {
            counter.setAttribute('data-header-cart-count', String(cart.body.item_count));
            counter.textContent = String(cart.body.item_count);
            counter.classList.toggle('visible', cart.body.item_count > 0);
          });
          this.dispatchEvent(new CustomEvent('ehobby-aov:added', { bubbles: true, detail: { variantId: body.id, quantity: Number(payload.get('quantity')) } }));
        } catch {
          this.dataset.feedback = 'attention';
          this.cartLink.hidden = false;
          this.finished = postStarted;
          this.button.disabled = postStarted || this.closest('.ehobby-aov__card')?.dataset.aovRejected === 'true';
          this.status.textContent = added ? this.dataset.refresh : this.dataset.uncertain;
        } finally {
          release();
          this.pending = false;
          this.form.removeAttribute('aria-busy');
          if (completed) {
            if (this.dataset.page !== 'cart' && this.dataset.addedShort) this.button.textContent = this.dataset.addedShort;
            this.cartLink.hidden = false;
            this.querySelector('[data-aov-select]')?.setAttribute('disabled', '');
          } else if (!this.finished && this.closest('.ehobby-aov__card')?.dataset.aovRejected !== 'true') {
            this.button.disabled = false;
            this.form.querySelectorAll('select').forEach(select => { select.disabled = false; });
          }
        }
      }
    });
  }
  if (!window.EhobbyAovMetrics) {
    const seen = new WeakSet();
    const timers = new Map();
    const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    const track = (name, card, extra = {}) => {
      try {
        const section = card?.closest('[data-aov-analytics]');
        if (!section || section.dataset.aovAnalytics !== 'true' || !allowed() || typeof window.gtag !== 'function') return false;
        if (!['ehobby_aov_view', 'ehobby_aov_click', 'ehobby_aov_add'].includes(name)) return false;
        const surface = section.dataset.aovSurface || card.dataset.aovSource;
        const addition = {};
        if (name === 'ehobby_aov_add') {
          const variantId = String(extra.variant_id || '');
          if (!/^[1-9]\d*$/.test(variantId) || !Number.isSafeInteger(extra.quantity) || extra.quantity <= 0) return false;
          if (extra.method !== undefined && !['single', 'bundle'].includes(extra.method)) return false;
          addition.aov_add_method = extra.method === 'bundle' ? 'bundle' : 'single';
          addition.variant_id = variantId;
          addition.quantity = extra.quantity;
        }
        window.gtag('event', name, {
          aov_product_id: card.dataset.aovProduct,
          aov_origin: card.dataset.aovOrigin,
          aov_placement: ['product', 'cart', 'drawer'].includes(surface) ? surface : 'unknown',
          aov_strategy: card.dataset.aovStrategy,
          ...addition
        });
        return true;
      } catch { return false; }
    };
    const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        clearTimeout(timers.get(entry.target));
        timers.delete(entry.target);
        if (!document.hidden && entry.isIntersecting && entry.intersectionRatio >= 0.5 && !seen.has(entry.target)) {
          timers.set(entry.target, setTimeout(() => {
            timers.delete(entry.target);
            if (!document.hidden && entry.target.isConnected && track('ehobby_aov_view', entry.target)) {
              seen.add(entry.target);
              observer.unobserve(entry.target);
            }
          }, 1000));
        }
      }
    }, { threshold: [0, 0.5] }) : null;
    const observe = () => {
      observer?.disconnect();
      for (const timer of timers.values()) clearTimeout(timer);
      timers.clear();
      if (document.hidden || !allowed()) return;
      document.querySelectorAll('[data-aov-analytics="true"] .ehobby-aov__card').forEach(card => {
        if (!seen.has(card)) observer?.observe(card);
      });
    };
    window.EhobbyAovMetrics = { track, observe };
    document.addEventListener('click', event => {
      const link = event.target.closest?.('.ehobby-aov__media, .ehobby-aov__product-title a');
      if (link) track('ehobby_aov_click', link.closest('.ehobby-aov__card'));
    });
    document.addEventListener('visitorConsentCollected', observe);
    document.addEventListener('visibilitychange', observe);
    document.addEventListener('shopify:section:load', observe);
    const initialize = () => {
      if (window.Shopify?.customerPrivacy) observe();
      else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) observe(); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  }
  } catch(e) { console.error(e); }
})();

})();
